<template>
  <g
    id="Exhaust-2"
    v-on:click="changeSeverity('leftExhaust')"
    :class="severityClass"
  >
    <g>
      <path
        class="cls-688"
        d="M393.77,86.04c2.44,0,4.29-.49,6.53-1.46,5.4-2.34,8.1-8.52,6.13-14.07l-10.64-30.05c-2.41-6.8-8.86-11.36-16.07-11.36h-56.86v5.46h56.86c4.9,0,9.3,3.11,10.93,7.73l10.64,30.05c1.01,2.86-.38,6.04-3.16,7.24-1.55,.67-2.68,1.01-4.37,1.01"
      />
      <path
        class="cls-503"
        d="M393.77,86.03c2.44,0,4.29-.49,6.53-1.46,5.4-2.34,8.09-8.51,6.13-14.06l-10.64-30.05c-2.4-6.79-8.86-11.36-16.07-11.36h-56.86s0,5.44,0,5.44h56.86c4.91,0,9.3,3.11,10.94,7.73l10.64,30.05c1.01,2.86-.38,6.04-3.16,7.25-1.55,.67-2.68,1.01-4.37,1.01"
      />
      <path
        class="cls-494"
        d="M393.77,86.02c2.44,0,4.29-.49,6.53-1.46,5.4-2.34,8.09-8.51,6.12-14.05l-10.64-30.05c-2.4-6.79-8.86-11.35-16.06-11.35h-56.86s0,5.43,0,5.43h56.86c4.91,0,9.31,3.11,10.94,7.74l10.64,30.05c1.01,2.86-.38,6.05-3.16,7.26-1.55,.67-2.68,1.01-4.37,1.01"
      />
      <path
        class="cls-534"
        d="M393.77,86.02c2.44,0,4.29-.49,6.53-1.46,5.39-2.33,8.08-8.5,6.12-14.04l-10.64-30.05c-2.4-6.79-8.85-11.35-16.05-11.35h-56.86s0,5.41,0,5.41h56.86c4.91,0,9.31,3.11,10.95,7.74l10.64,30.05c1.01,2.87-.38,6.06-3.17,7.26-1.55,.67-2.68,1.01-4.38,1.01"
      />
      <path
        class="cls-556"
        d="M393.77,86.01c2.44,0,4.29-.49,6.52-1.46,5.39-2.33,8.08-8.5,6.12-14.03l-10.64-30.05c-2.4-6.78-8.85-11.34-16.05-11.34h-56.86s0,5.4,0,5.4h56.86c4.91,0,9.32,3.11,10.96,7.74l10.64,30.05c1.02,2.87-.38,6.06-3.17,7.27-1.56,.67-2.68,1.01-4.38,1.01"
      />
      <path
        class="cls-609"
        d="M393.77,86c2.44,0,4.29-.49,6.52-1.46,5.39-2.33,8.07-8.49,6.11-14.02l-10.64-30.05c-2.4-6.78-8.85-11.34-16.04-11.34h-56.86s0,5.39,0,5.39h56.86c4.92,0,9.32,3.11,10.96,7.75l10.64,30.05c1.02,2.87-.38,6.07-3.17,7.28-1.56,.67-2.69,1.02-4.38,1.02"
      />
      <path
        class="cls-607"
        d="M393.77,85.99c2.43,0,4.28-.49,6.52-1.46,5.38-2.33,8.07-8.49,6.11-14.01l-10.64-30.05c-2.4-6.78-8.84-11.33-16.04-11.33h-56.86s0,5.37,0,5.37h56.86c4.92,0,9.33,3.12,10.97,7.75l10.64,30.05c1.02,2.88-.38,6.08-3.18,7.29-1.56,.67-2.69,1.02-4.38,1.02"
      />
      <path
        class="cls-606"
        d="M393.77,85.99c2.43,0,4.28-.49,6.52-1.46,5.38-2.33,8.06-8.48,6.1-14.01l-10.64-30.05c-2.4-6.78-8.84-11.33-16.03-11.33h-56.86s0,5.36,0,5.36h56.86c4.92,0,9.33,3.12,10.98,7.76l10.64,30.05c1.02,2.88-.38,6.09-3.18,7.3-1.56,.67-2.69,1.02-4.39,1.02"
      />
      <path
        class="cls-552"
        d="M393.77,85.98c2.43,0,4.28-.49,6.51-1.46,5.38-2.33,8.06-8.47,6.1-14l-10.64-30.05c-2.4-6.77-8.84-11.32-16.02-11.32h-56.86s0,5.35,0,5.35h56.86c4.93,0,9.34,3.12,10.98,7.76l10.64,30.05c1.02,2.88-.38,6.09-3.19,7.31-1.56,.67-2.69,1.02-4.39,1.02"
      />
      <path
        class="cls-596"
        d="M393.77,85.97c2.43,0,4.28-.49,6.51-1.46,5.37-2.33,8.05-8.47,6.1-13.99l-10.64-30.05c-2.4-6.77-8.83-11.32-16.02-11.32h-56.86s0,5.33,0,5.33h56.86c4.93,0,9.34,3.12,10.99,7.77l10.64,30.05c1.02,2.89-.38,6.1-3.19,7.32-1.56,.68-2.69,1.02-4.39,1.02"
      />
      <path
        class="cls-545"
        d="M393.77,85.97c2.43,0,4.28-.49,6.51-1.46,5.37-2.32,8.05-8.46,6.09-13.98l-10.64-30.05c-2.4-6.77-8.83-11.32-16.01-11.32h-56.86s0,5.32,0,5.32h56.86c4.93,0,9.35,3.12,11,7.77l10.64,30.05c1.02,2.89-.38,6.11-3.19,7.32-1.56,.68-2.7,1.02-4.4,1.02"
      />
      <path
        class="cls-576"
        d="M393.77,85.96c2.43,0,4.28-.49,6.51-1.45,5.37-2.32,8.04-8.46,6.09-13.97l-10.64-30.05c-2.39-6.77-8.83-11.31-16-11.31h-56.86s0,5.3,0,5.3h56.86c4.93,0,9.36,3.13,11,7.78l10.64,30.05c1.02,2.89-.38,6.11-3.2,7.33-1.56,.68-2.7,1.02-4.4,1.02"
      />
      <path
        class="cls-648"
        d="M393.77,85.95c2.43,0,4.27-.49,6.5-1.45,5.36-2.32,8.04-8.45,6.09-13.96l-10.64-30.05c-2.39-6.76-8.82-11.31-16-11.31h-56.86s0,5.29,0,5.29h56.86c4.94,0,9.36,3.13,11.01,7.78l10.64,30.05c1.03,2.9-.38,6.12-3.2,7.34-1.56,.68-2.7,1.02-4.4,1.02"
      />
      <path
        class="cls-677"
        d="M393.77,85.95c2.43,0,4.27-.49,6.5-1.45,5.36-2.32,8.03-8.45,6.08-13.95l-10.64-30.05c-2.39-6.76-8.82-11.3-15.99-11.3h-56.86s0,5.28,0,5.28h56.86c4.94,0,9.37,3.13,11.02,7.79l10.64,30.05c1.03,2.9-.38,6.13-3.2,7.35-1.56,.68-2.7,1.02-4.4,1.02"
      />
      <path
        class="cls-647"
        d="M393.77,85.94c2.43,0,4.27-.49,6.5-1.45,5.36-2.32,8.03-8.44,6.08-13.95l-10.64-30.05c-2.39-6.76-8.82-11.3-15.98-11.3h-56.86s0,5.26,0,5.26h56.86c4.94,0,9.37,3.13,11.02,7.79l10.64,30.05c1.03,2.9-.38,6.14-3.21,7.36-1.56,.68-2.7,1.02-4.41,1.02"
      />
      <path
        class="cls-646"
        d="M393.77,85.93c2.43,0,4.27-.49,6.5-1.45,5.35-2.32,8.02-8.44,6.07-13.94l-10.64-30.05c-2.39-6.75-8.81-11.29-15.98-11.29h-56.86s0,5.25,0,5.25h56.86c4.95,0,9.38,3.13,11.03,7.79l10.64,30.05c1.03,2.91-.38,6.14-3.21,7.37-1.57,.68-2.71,1.02-4.41,1.02"
      />
      <path
        class="cls-665"
        d="M393.77,85.93c2.43,0,4.27-.49,6.49-1.45,5.35-2.32,8.02-8.43,6.07-13.93l-10.64-30.05c-2.39-6.75-8.81-11.29-15.97-11.29h-56.86s0,5.24,0,5.24h56.86c4.95,0,9.38,3.13,11.03,7.8l10.64,30.05c1.03,2.91-.38,6.15-3.22,7.38-1.57,.68-2.71,1.02-4.41,1.02"
      />
      <path
        class="cls-638"
        d="M393.77,85.92c2.42,0,4.27-.49,6.49-1.45,5.35-2.31,8.01-8.43,6.07-13.92l-10.64-30.05c-2.39-6.75-8.8-11.28-15.96-11.28h-56.86s0,5.22,0,5.22h56.86c4.95,0,9.39,3.14,11.04,7.8l10.64,30.05c1.03,2.91-.38,6.16-3.22,7.38-1.57,.68-2.71,1.02-4.42,1.02"
      />
      <path
        class="cls-559"
        d="M393.77,85.91c2.42,0,4.26-.49,6.49-1.45,5.34-2.31,8.01-8.42,6.06-13.91l-10.64-30.05c-2.39-6.75-8.8-11.28-15.96-11.28h-56.86s0,5.21,0,5.21h56.86c4.95,0,9.39,3.14,11.05,7.81l10.64,30.05c1.03,2.92-.38,6.16-3.22,7.39-1.57,.68-2.71,1.02-4.42,1.02"
      />
      <path
        class="cls-539"
        d="M393.77,85.91c2.42,0,4.26-.49,6.49-1.45,5.34-2.31,8-8.42,6.06-13.9l-10.64-30.05c-2.39-6.74-8.8-11.27-15.95-11.27h-56.86s0,5.19,0,5.19h56.86c4.96,0,9.4,3.14,11.05,7.81l10.64,30.05c1.03,2.92-.38,6.17-3.23,7.4-1.57,.68-2.71,1.02-4.42,1.02"
      />
      <path
        class="cls-89"
        d="M393.77,85.9c2.42,0,4.26-.49,6.48-1.45,5.34-2.31,8-8.41,6.06-13.89l-10.64-30.05c-2.39-6.74-8.79-11.27-15.94-11.27h-56.86s0,5.18,0,5.18h56.86c4.96,0,9.41,3.14,11.06,7.82l10.64,30.05c1.03,2.92-.38,6.18-3.23,7.41-1.57,.68-2.72,1.02-4.43,1.02"
      />
      <path
        class="cls-90"
        d="M393.77,85.89c2.42,0,4.26-.49,6.48-1.45,5.33-2.31,7.99-8.41,6.05-13.89l-10.64-30.05c-2.39-6.74-8.79-11.27-15.94-11.27h-56.86s0,5.17,0,5.17h56.86c4.96,0,9.41,3.14,11.07,7.82l10.64,30.05c1.04,2.93-.38,6.19-3.23,7.42-1.57,.68-2.72,1.02-4.43,1.02"
      />
      <path
        class="cls-194"
        d="M393.76,85.88c2.42,0,4.26-.49,6.48-1.45,5.33-2.31,7.99-8.4,6.05-13.88l-10.64-30.05c-2.38-6.74-8.79-11.26-15.93-11.26h-56.86s0,5.15,0,5.15h56.86c4.97,0,9.42,3.15,11.07,7.83l10.64,30.05c1.04,2.93-.38,6.19-3.24,7.43-1.57,.68-2.72,1.02-4.43,1.02"
      />
      <path
        class="cls-21"
        d="M393.76,85.88c2.42,0,4.26-.49,6.48-1.45,5.33-2.31,7.98-8.4,6.05-13.87l-10.64-30.05c-2.38-6.73-8.78-11.26-15.93-11.26h-56.86s0,5.14,0,5.14h56.86c4.97,0,9.42,3.15,11.08,7.83l10.64,30.05c1.04,2.93-.39,6.2-3.24,7.44-1.57,.68-2.72,1.03-4.43,1.03"
      />
      <path
        class="cls-85"
        d="M393.76,85.87c2.42,0,4.25-.49,6.47-1.45,5.32-2.3,7.98-8.39,6.04-13.86l-10.64-30.05c-2.38-6.73-8.78-11.25-15.92-11.25h-56.86s0,5.13,0,5.13h56.86c4.97,0,9.43,3.15,11.09,7.84l10.64,30.05c1.04,2.94-.39,6.21-3.24,7.44-1.57,.68-2.72,1.03-4.44,1.03"
      />
      <path
        class="cls-17"
        d="M393.76,85.86c2.42,0,4.25-.49,6.47-1.45,5.32-2.3,7.97-8.39,6.04-13.85l-10.64-30.05c-2.38-6.73-8.78-11.25-15.91-11.25h-56.86s0,5.11,0,5.11h56.86c4.97,0,9.43,3.15,11.09,7.84l10.64,30.05c1.04,2.94-.39,6.21-3.25,7.45-1.57,.68-2.73,1.03-4.44,1.03"
      />
      <path
        class="cls-25"
        d="M393.76,85.86c2.42,0,4.25-.49,6.47-1.45,5.32-2.3,7.97-8.38,6.03-13.84l-10.64-30.05c-2.38-6.72-8.77-11.24-15.91-11.24h-56.86s0,5.1,0,5.1h56.86c4.98,0,9.44,3.15,11.1,7.85l10.64,30.05c1.04,2.94-.39,6.22-3.25,7.46-1.57,.68-2.73,1.03-4.44,1.03"
      />
      <path
        class="cls-67"
        d="M393.76,85.85c2.41,0,4.25-.49,6.47-1.45,5.31-2.3,7.96-8.38,6.03-13.83l-10.64-30.05c-2.38-6.72-8.77-11.24-15.9-11.24h-56.86s0,5.08,0,5.08h56.86c4.98,0,9.44,3.15,11.11,7.85l10.64,30.05c1.04,2.95-.39,6.23-3.26,7.47-1.58,.68-2.73,1.03-4.45,1.03"
      />
      <path
        class="cls-99"
        d="M393.76,85.84c2.41,0,4.25-.49,6.46-1.45,5.31-2.3,7.96-8.37,6.03-13.83l-10.64-30.05c-2.38-6.72-8.77-11.23-15.89-11.23h-56.86s0,5.07,0,5.07h56.86c4.98,0,9.45,3.16,11.11,7.85l10.64,30.05c1.04,2.95-.39,6.24-3.26,7.48-1.58,.68-2.73,1.03-4.45,1.03"
      />
      <path
        class="cls-518"
        d="M393.76,85.84c2.41,0,4.25-.49,6.46-1.44,5.31-2.3,7.95-8.37,6.02-13.82l-10.64-30.05c-2.38-6.72-8.76-11.23-15.89-11.23h-56.86s0,5.06,0,5.06h56.86c4.99,0,9.45,3.16,11.12,7.86l10.64,30.05c1.05,2.95-.39,6.24-3.26,7.49-1.58,.68-2.73,1.03-4.45,1.03"
      />
      <path
        class="cls-467"
        d="M393.76,85.83c2.41,0,4.24-.49,6.46-1.44,5.3-2.3,7.95-8.36,6.02-13.81l-10.64-30.05c-2.38-6.71-8.76-11.22-15.88-11.22h-56.86s0,5.04,0,5.04h56.86c4.99,0,9.46,3.16,11.13,7.86l10.64,30.05c1.05,2.96-.39,6.25-3.27,7.5-1.58,.68-2.74,1.03-4.45,1.03"
      />
      <path
        class="cls-470"
        d="M393.76,85.82c2.41,0,4.24-.49,6.46-1.44,5.3-2.29,7.94-8.36,6.02-13.8l-10.64-30.05c-2.38-6.71-8.75-11.22-15.87-11.22h-56.86s0,5.03,0,5.03h56.86c4.99,0,9.47,3.16,11.13,7.87l10.64,30.05c1.05,2.96-.39,6.26-3.27,7.5-1.58,.68-2.74,1.03-4.46,1.03"
      />
      <path
        class="cls-477"
        d="M393.76,85.82c2.41,0,4.24-.49,6.45-1.44,5.3-2.29,7.94-8.35,6.01-13.79l-10.64-30.05c-2.37-6.71-8.75-11.22-15.87-11.22h-56.86s0,5.02,0,5.02h56.86c5,0,9.47,3.16,11.14,7.87l10.64,30.05c1.05,2.96-.39,6.26-3.27,7.51-1.58,.68-2.74,1.03-4.46,1.03"
      />
      <path
        class="cls-480"
        d="M393.76,85.81c2.41,0,4.24-.49,6.45-1.44,5.29-2.29,7.93-8.34,6.01-13.78l-10.64-30.05c-2.37-6.71-8.75-11.21-15.86-11.21h-56.86s0,5,0,5h56.86c5,0,9.48,3.17,11.14,7.88l10.64,30.05c1.05,2.97-.39,6.27-3.28,7.52-1.58,.68-2.74,1.03-4.46,1.03"
      />
      <path
        class="cls-626"
        d="M393.76,85.8c2.41,0,4.24-.49,6.45-1.44,5.29-2.29,7.93-8.34,6-13.77l-10.64-30.05c-2.37-6.7-8.74-11.21-15.85-11.21h-56.86s0,4.99,0,4.99h56.86c5,0,9.48,3.17,11.15,7.88l10.64,30.05c1.05,2.97-.39,6.28-3.28,7.53-1.58,.68-2.74,1.03-4.47,1.03"
      />
      <path
        class="cls-679"
        d="M393.76,85.8c2.41,0,4.24-.49,6.45-1.44,5.29-2.29,7.92-8.33,6-13.77l-10.64-30.05c-2.37-6.7-8.74-11.2-15.85-11.2h-56.86s0,4.98,0,4.98h56.86c5,0,9.49,3.17,11.16,7.89l10.64,30.05c1.05,2.97-.39,6.29-3.29,7.54-1.58,.68-2.75,1.03-4.47,1.03"
      />
      <path
        class="cls-197"
        d="M393.76,85.79c2.41,0,4.23-.48,6.44-1.44,5.28-2.29,7.92-8.33,6-13.76l-10.64-30.05c-2.37-6.7-8.74-11.2-15.84-11.2h-56.86s0,4.96,0,4.96h56.86c5.01,0,9.49,3.17,11.16,7.89l10.64,30.05c1.05,2.98-.39,6.29-3.29,7.55-1.58,.69-2.75,1.03-4.47,1.03"
      />
      <path
        class="cls-81"
        d="M393.76,85.78c2.41,0,4.23-.48,6.44-1.44,5.28-2.29,7.91-8.32,5.99-13.75l-10.64-30.05c-2.37-6.69-8.73-11.19-15.83-11.19h-56.86s0,4.95,0,4.95h56.86c5.01,0,9.5,3.17,11.17,7.9l10.64,30.05c1.06,2.98-.39,6.3-3.29,7.56-1.58,.69-2.75,1.03-4.48,1.03"
      />
      <path
        class="cls-652"
        d="M393.76,85.77c2.4,0,4.23-.48,6.44-1.44,5.28-2.28,7.91-8.32,5.99-13.74l-10.64-30.05c-2.37-6.69-8.73-11.19-15.83-11.19h-56.86s0,4.93,0,4.93h56.86c5.01,0,9.5,3.17,11.18,7.9l10.64,30.05c1.06,2.98-.39,6.31-3.3,7.56-1.58,.69-2.75,1.03-4.48,1.03"
      />
      <path
        class="cls-658"
        d="M393.76,85.77c2.4,0,4.23-.48,6.44-1.44,5.27-2.28,7.9-8.31,5.99-13.73l-10.64-30.05c-2.37-6.69-8.73-11.18-15.82-11.18h-56.86s0,4.92,0,4.92h56.86c5.02,0,9.51,3.18,11.18,7.9l10.64,30.05c1.06,2.99-.39,6.31-3.3,7.57-1.59,.69-2.75,1.03-4.48,1.03"
      />
      <path
        class="cls-662"
        d="M393.76,85.76c2.4,0,4.23-.48,6.43-1.44,5.27-2.28,7.9-8.31,5.98-13.72l-10.64-30.05c-2.37-6.69-8.72-11.18-15.82-11.18h-56.86s0,4.91,0,4.91h56.86c5.02,0,9.52,3.18,11.19,7.91l10.64,30.05c1.06,2.99-.39,6.32-3.3,7.58-1.59,.69-2.76,1.03-4.48,1.03"
      />
      <path
        class="cls-694"
        d="M393.76,85.75c2.4,0,4.23-.48,6.43-1.44,5.27-2.28,7.89-8.3,5.98-13.71l-10.64-30.05c-2.37-6.68-8.72-11.17-15.81-11.17h-56.86s0,4.89,0,4.89h56.86c5.02,0,9.52,3.18,11.2,7.91l10.64,30.05c1.06,2.99-.39,6.33-3.31,7.59-1.59,.69-2.76,1.04-4.49,1.04"
      />
      <path
        class="cls-668"
        d="M393.76,85.75c2.4,0,4.22-.48,6.43-1.44,5.26-2.28,7.89-8.3,5.97-13.71l-10.64-30.05c-2.36-6.68-8.72-11.17-15.8-11.17h-56.86s0,4.88,0,4.88h56.86c5.02,0,9.53,3.18,11.2,7.92l10.64,30.05c1.06,3-.39,6.34-3.31,7.6-1.59,.69-2.76,1.04-4.49,1.04"
      />
      <path
        class="cls-672"
        d="M393.76,85.74c2.4,0,4.22-.48,6.43-1.44,5.26-2.28,7.88-8.29,5.97-13.7l-10.64-30.05c-2.36-6.68-8.71-11.16-15.8-11.16h-56.86s0,4.87,0,4.87h56.86c5.03,0,9.53,3.18,11.21,7.92l10.64,30.05c1.06,3-.39,6.34-3.32,7.61-1.59,.69-2.76,1.04-4.49,1.04"
      />
      <path
        class="cls-712"
        d="M393.76,85.73c2.4,0,4.22-.48,6.42-1.44,5.26-2.28,7.88-8.29,5.97-13.69l-10.64-30.05c-2.36-6.68-8.71-11.16-15.79-11.16h-56.86s0,4.85,0,4.85h56.86c5.03,0,9.54,3.19,11.22,7.93l10.64,30.05c1.06,3-.39,6.35-3.32,7.62-1.59,.69-2.76,1.04-4.5,1.04"
      />
      <path
        class="cls-104"
        d="M393.76,85.73c2.4,0,4.22-.48,6.42-1.44,5.25-2.27,7.87-8.28,5.96-13.68l-10.64-30.05c-2.36-6.67-8.7-11.16-15.78-11.16h-56.86s0,4.84,0,4.84h56.86c5.03,0,9.54,3.19,11.22,7.93l10.64,30.05c1.06,3.01-.4,6.36-3.32,7.62-1.59,.69-2.77,1.04-4.5,1.04"
      />
      <path
        class="cls-64"
        d="M393.76,85.72c2.4,0,4.22-.48,6.42-1.44,5.25-2.27,7.87-8.28,5.96-13.67l-10.64-30.05c-2.36-6.67-8.7-11.15-15.78-11.15h-56.86s0,4.82,0,4.82h56.86c5.04,0,9.55,3.19,11.23,7.94l10.64,30.05c1.07,3.01-.4,6.36-3.33,7.63-1.59,.69-2.77,1.04-4.5,1.04"
      />
      <path
        class="cls-72"
        d="M393.76,85.71c2.4,0,4.22-.48,6.42-1.43,5.25-2.27,7.86-8.27,5.96-13.66l-10.64-30.05c-2.36-6.67-8.7-11.15-15.77-11.15h-56.86s0,4.81,0,4.81h56.86c5.04,0,9.55,3.19,11.23,7.94l10.64,30.05c1.07,3.01-.4,6.37-3.33,7.64-1.59,.69-2.77,1.04-4.5,1.04"
      />
      <path
        class="cls-75"
        d="M393.76,85.71c2.4,0,4.21-.48,6.41-1.43,5.24-2.27,7.86-8.27,5.95-13.65l-10.64-30.05c-2.36-6.66-8.69-11.14-15.76-11.14h-56.86s0,4.8,0,4.8h56.86c5.04,0,9.56,3.19,11.24,7.95l10.64,30.05c1.07,3.02-.4,6.38-3.33,7.65-1.59,.69-2.77,1.04-4.51,1.04"
      />
      <path
        class="cls-464"
        d="M393.76,85.7c2.39,0,4.21-.48,6.41-1.43,5.24-2.27,7.85-8.26,5.95-13.65l-10.64-30.05c-2.36-6.66-8.69-11.14-15.76-11.14h-56.86s0,4.78,0,4.78h56.86c5.04,0,9.56,3.2,11.25,7.95l10.64,30.05c1.07,3.02-.4,6.39-3.34,7.66-1.59,.69-2.77,1.04-4.51,1.04"
      />
      <path
        class="cls-701"
        d="M393.76,85.69c2.39,0,4.21-.48,6.41-1.43,5.24-2.27,7.85-8.26,5.94-13.64l-10.64-30.05c-2.36-6.66-8.69-11.13-15.75-11.13h-56.86s0,4.77,0,4.77h56.86c5.05,0,9.57,3.2,11.25,7.95l10.64,30.05c1.07,3.02-.4,6.39-3.34,7.67-1.6,.69-2.78,1.04-4.51,1.04"
      />
      <path
        class="cls-622"
        d="M393.76,85.69c2.39,0,4.21-.48,6.41-1.43,5.23-2.27,7.84-8.25,5.94-13.63l-10.64-30.05c-2.36-6.66-8.68-11.13-15.74-11.13h-56.86s0,4.76,0,4.76h56.86c5.05,0,9.58,3.2,11.26,7.96l10.64,30.05c1.07,3.03-.4,6.4-3.35,7.68-1.6,.69-2.78,1.04-4.52,1.04"
      />
      <path
        class="cls-620"
        d="M393.76,85.68c2.39,0,4.21-.48,6.4-1.43,5.23-2.26,7.84-8.25,5.94-13.62l-10.64-30.05c-2.36-6.65-8.68-11.12-15.74-11.12h-56.86s0,4.74,0,4.74h56.86c5.05,0,9.58,3.2,11.27,7.96l10.64,30.05c1.07,3.03-.4,6.41-3.35,7.68-1.6,.69-2.78,1.04-4.52,1.04"
      />
      <path
        class="cls-126"
        d="M393.76,85.67c2.39,0,4.21-.48,6.4-1.43,5.23-2.26,7.83-8.24,5.93-13.61l-10.64-30.05c-2.35-6.65-8.68-11.12-15.73-11.12h-56.86s0,4.73,0,4.73h56.86c5.06,0,9.59,3.2,11.27,7.97l10.64,30.05c1.07,3.04-.4,6.41-3.35,7.69-1.6,.69-2.78,1.04-4.52,1.04"
      />
      <path
        class="cls-219"
        d="M393.76,85.67c2.39,0,4.2-.48,6.4-1.43,5.22-2.26,7.83-8.24,5.93-13.6l-10.64-30.05c-2.35-6.65-8.67-11.11-15.72-11.11h-56.86s0,4.71,0,4.71h56.86c5.06,0,9.59,3.2,11.28,7.97l10.64,30.05c1.08,3.04-.4,6.42-3.36,7.7-1.6,.69-2.78,1.04-4.53,1.04"
      />
      <path
        class="cls-509"
        d="M393.76,85.66c2.39,0,4.2-.48,6.39-1.43,5.22-2.26,7.82-8.23,5.93-13.59l-10.64-30.05c-2.35-6.65-8.67-11.11-15.72-11.11h-56.86s0,4.7,0,4.7h56.86c5.06,0,9.6,3.21,11.29,7.98l10.64,30.05c1.08,3.04-.4,6.43-3.36,7.71-1.6,.69-2.79,1.04-4.53,1.04"
      />
      <path
        class="cls-525"
        d="M393.76,85.65c2.39,0,4.2-.48,6.39-1.43,5.22-2.26,7.82-8.23,5.92-13.58l-10.64-30.05c-2.35-6.64-8.67-11.11-15.71-11.11h-56.86s0,4.69,0,4.69h56.86c5.06,0,9.6,3.21,11.29,7.98l10.64,30.05c1.08,3.05-.4,6.44-3.36,7.72-1.6,.69-2.79,1.04-4.53,1.04"
      />
      <path
        class="cls-521"
        d="M393.76,85.64c2.39,0,4.2-.48,6.39-1.43,5.21-2.26,7.81-8.22,5.92-13.58l-10.64-30.05c-2.35-6.64-8.66-11.1-15.71-11.1h-56.86s0,4.67,0,4.67h56.86c5.07,0,9.61,3.21,11.3,7.99l10.64,30.05c1.08,3.05-.4,6.44-3.37,7.73-1.6,.69-2.79,1.04-4.53,1.04"
      />
      <path
        class="cls-512"
        d="M393.76,85.64c2.39,0,4.2-.48,6.39-1.43,5.21-2.26,7.81-8.21,5.91-13.57l-10.64-30.05c-2.35-6.64-8.66-11.1-15.7-11.1h-56.86s0,4.66,0,4.66h56.86c5.07,0,9.61,3.21,11.31,7.99l10.64,30.05c1.08,3.05-.4,6.45-3.37,7.74-1.6,.69-2.79,1.05-4.54,1.05"
      />
      <path
        class="cls-142"
        d="M393.76,85.63c2.38,0,4.2-.48,6.38-1.43,5.21-2.25,7.8-8.21,5.91-13.56l-10.64-30.05c-2.35-6.63-8.65-11.09-15.69-11.09h-56.86s0,4.65,0,4.65h56.86c5.07,0,9.62,3.21,11.31,8l10.64,30.05c1.08,3.06-.4,6.46-3.38,7.75-1.6,.69-2.79,1.05-4.54,1.05"
      />
      <path
        class="cls-162"
        d="M393.76,85.62c2.38,0,4.19-.48,6.38-1.43,5.2-2.25,7.8-8.2,5.91-13.55l-10.64-30.05c-2.35-6.63-8.65-11.09-15.69-11.09h-56.86s0,4.63,0,4.63h56.86c5.08,0,9.63,3.22,11.32,8l10.64,30.05c1.08,3.06-.4,6.46-3.38,7.75-1.6,.69-2.8,1.05-4.54,1.05"
      />
      <path
        class="cls-214"
        d="M393.76,85.62c2.38,0,4.19-.48,6.38-1.43,5.2-2.25,7.79-8.2,5.9-13.54l-10.64-30.05c-2.35-6.63-8.65-11.08-15.68-11.08h-56.86s0,4.62,0,4.62h56.86c5.08,0,9.63,3.22,11.33,8.01l10.64,30.05c1.08,3.06-.4,6.47-3.38,7.76-1.6,.69-2.8,1.05-4.55,1.05"
      />
      <path
        class="cls-211"
        d="M393.76,85.61c2.38,0,4.19-.48,6.38-1.43,5.2-2.25,7.79-8.19,5.9-13.53l-10.64-30.05c-2.35-6.63-8.64-11.08-15.67-11.08h-56.86s0,4.6,0,4.6h56.86c5.08,0,9.64,3.22,11.33,8.01l10.64,30.05c1.09,3.07-.4,6.48-3.39,7.77-1.61,.69-2.8,1.05-4.55,1.05"
      />
      <path
        class="cls-175"
        d="M393.76,85.6c2.38,0,4.19-.48,6.37-1.43,5.19-2.25,7.78-8.19,5.9-13.52l-10.64-30.05c-2.34-6.62-8.64-11.07-15.67-11.07h-56.86s0,4.59,0,4.59h56.86c5.08,0,9.64,3.22,11.34,8.01l10.64,30.05c1.09,3.07-.4,6.49-3.39,7.78-1.61,.7-2.8,1.05-4.55,1.05"
      />
      <path
        class="cls-180"
        d="M393.76,85.6c2.38,0,4.19-.48,6.37-1.42,5.19-2.25,7.78-8.18,5.89-13.52l-10.64-30.05c-2.34-6.62-8.64-11.07-15.66-11.07h-56.86s0,4.58,0,4.58h56.86c5.09,0,9.65,3.22,11.34,8.02l10.64,30.05c1.09,3.07-.4,6.49-3.39,7.79-1.61,.7-2.8,1.05-4.55,1.05"
      />
      <path
        class="cls-178"
        d="M393.76,85.59c2.38,0,4.19-.48,6.37-1.42,5.19-2.25,7.77-8.18,5.89-13.51l-10.64-30.05c-2.34-6.62-8.63-11.06-15.65-11.06h-56.86s0,4.56,0,4.56h56.86c5.09,0,9.65,3.22,11.35,8.02l10.64,30.05c1.09,3.08-.4,6.5-3.4,7.8-1.61,.7-2.81,1.05-4.56,1.05"
      />
      <path
        class="cls-119"
        d="M393.76,85.58c2.38,0,4.18-.48,6.37-1.42,5.18-2.24,7.77-8.17,5.88-13.5l-10.64-30.05c-2.34-6.62-8.63-11.06-15.65-11.06h-56.86s0,4.55,0,4.55h56.86c5.09,0,9.66,3.23,11.36,8.03l10.64,30.05c1.09,3.08-.4,6.51-3.4,7.81-1.61,.7-2.81,1.05-4.56,1.05"
      />
      <path
        class="cls-216"
        d="M393.76,85.58c2.38,0,4.18-.48,6.36-1.42,5.18-2.24,7.76-8.17,5.88-13.49l-10.64-30.05c-2.34-6.61-8.63-11.06-15.64-11.06h-56.86s0,4.54,0,4.54h56.86c5.1,0,9.66,3.23,11.36,8.03l10.64,30.05c1.09,3.08-.4,6.51-3.41,7.81-1.61,.7-2.81,1.05-4.56,1.05"
      />
      <path
        class="cls-457"
        d="M393.76,85.57c2.38,0,4.18-.48,6.36-1.42,5.18-2.24,7.76-8.16,5.88-13.48l-10.64-30.05c-2.34-6.61-8.62-11.05-15.63-11.05h-56.86s0,4.52,0,4.52h56.86c5.1,0,9.67,3.23,11.37,8.04l10.64,30.05c1.09,3.09-.41,6.52-3.41,7.82-1.61,.7-2.81,1.05-4.57,1.05"
      />
      <path
        class="cls-491"
        d="M393.75,85.56c2.38,0,4.18-.48,6.36-1.42,5.17-2.24,7.75-8.16,5.87-13.47l-10.64-30.05c-2.34-6.61-8.62-11.05-15.63-11.05h-56.86s0,4.51,0,4.51h56.86c5.1,0,9.67,3.23,11.38,8.04l10.64,30.05c1.09,3.09-.41,6.53-3.41,7.83-1.61,.7-2.81,1.05-4.57,1.05"
      />
      <path
        class="cls-489"
        d="M393.75,85.56c2.37,0,4.18-.48,6.36-1.42,5.17-2.24,7.75-8.15,5.87-13.46l-10.64-30.05c-2.34-6.6-8.62-11.04-15.62-11.04h-56.86s0,4.49,0,4.49h56.86c5.11,0,9.68,3.23,11.38,8.05l10.64,30.05c1.09,3.09-.41,6.54-3.42,7.84-1.61,.7-2.82,1.05-4.57,1.05"
      />
      <path
        class="cls-108"
        d="M393.75,85.55c2.37,0,4.18-.48,6.35-1.42,5.17-2.24,7.74-8.15,5.87-13.46l-10.64-30.05c-2.34-6.6-8.61-11.04-15.61-11.04h-56.86s0,4.48,0,4.48h56.86c5.11,0,9.69,3.24,11.39,8.05l10.64,30.05c1.1,3.1-.41,6.54-3.42,7.85-1.61,.7-2.82,1.05-4.57,1.05"
      />
      <path
        class="cls-94"
        d="M393.75,85.54c2.37,0,4.17-.48,6.35-1.42,5.16-2.24,7.74-8.14,5.86-13.45l-10.64-30.05c-2.34-6.6-8.61-11.03-15.61-11.03h-56.86s0,4.47,0,4.47h56.86c5.11,0,9.69,3.24,11.4,8.06l10.64,30.05c1.1,3.1-.41,6.55-3.42,7.86-1.61,.7-2.82,1.05-4.58,1.05"
      />
      <path
        class="cls-511"
        d="M393.75,85.53c2.37,0,4.17-.48,6.35-1.42,5.16-2.23,7.73-8.14,5.86-13.44l-10.64-30.05c-2.33-6.6-8.6-11.03-15.6-11.03h-56.86s0,4.45,0,4.45h56.86c5.11,0,9.7,3.24,11.4,8.06l10.64,30.05c1.1,3.1-.41,6.56-3.43,7.87-1.62,.7-2.82,1.05-4.58,1.05"
      />
      <path
        class="cls-531"
        d="M393.75,85.53c2.37,0,4.17-.48,6.35-1.42,5.16-2.23,7.73-8.13,5.85-13.43l-10.64-30.05c-2.33-6.59-8.6-11.02-15.6-11.02h-56.86s0,4.44,0,4.44h56.86c5.12,0,9.7,3.24,11.41,8.06l10.64,30.05c1.1,3.11-.41,6.56-3.43,7.87-1.62,.7-2.82,1.05-4.58,1.05"
      />
      <path
        class="cls-164"
        d="M393.75,85.52c2.37,0,4.17-.48,6.34-1.42,5.16-2.23,7.72-8.13,5.85-13.42l-10.64-30.05c-2.33-6.59-8.6-11.02-15.59-11.02h-56.86s0,4.43,0,4.43h56.86c5.12,0,9.71,3.24,11.42,8.07l10.64,30.05c1.1,3.11-.41,6.57-3.44,7.88-1.62,.7-2.83,1.05-4.59,1.05"
      />
      <path
        class="cls-160"
        d="M393.75,85.51c2.37,0,4.17-.48,6.34-1.42,5.15-2.23,7.72-8.12,5.85-13.41l-10.64-30.05c-2.33-6.59-8.59-11.01-15.58-11.01h-56.86s0,4.41,0,4.41h56.86c5.12,0,9.71,3.24,11.42,8.07l10.64,30.05c1.1,3.11-.41,6.58-3.44,7.89-1.62,.7-2.83,1.06-4.59,1.06"
      />
      <path
        class="cls-165"
        d="M393.75,85.51c2.37,0,4.17-.48,6.34-1.42,5.15-2.23,7.72-8.12,5.84-13.4l-10.64-30.05c-2.33-6.59-8.59-11.01-15.58-11.01h-56.86s0,4.4,0,4.4h56.86c5.13,0,9.72,3.25,11.43,8.08l10.64,30.05c1.1,3.12-.41,6.59-3.44,7.9-1.62,.7-2.83,1.06-4.59,1.06"
      />
      <path
        class="cls-124"
        d="M393.75,85.5c2.37,0,4.16-.48,6.34-1.42,5.15-2.23,7.71-8.11,5.84-13.4l-10.64-30.05c-2.33-6.58-8.59-11-15.57-11h-56.86s0,4.39,0,4.39h56.86c5.13,0,9.72,3.25,11.44,8.08l10.64,30.05c1.1,3.12-.41,6.59-3.45,7.91-1.62,.7-2.83,1.06-4.6,1.06"
      />
      <path
        class="cls-129"
        d="M393.75,85.49c2.37,0,4.16-.48,6.33-1.42,5.14-2.23,7.71-8.11,5.84-13.39l-10.64-30.05c-2.33-6.58-8.58-11-15.56-11h-56.86s0,4.37,0,4.37h56.86c5.13,0,9.73,3.25,11.44,8.09l10.64,30.05c1.11,3.12-.41,6.6-3.45,7.92-1.62,.7-2.83,1.06-4.6,1.06"
      />
      <path
        class="cls-169"
        d="M393.75,85.49c2.37,0,4.16-.48,6.33-1.42,5.14-2.22,7.7-8.1,5.83-13.38l-10.64-30.05c-2.33-6.58-8.58-11-15.56-11h-56.86s0,4.36,0,4.36h56.86c5.13,0,9.74,3.25,11.45,8.09l10.64,30.05c1.11,3.13-.41,6.61-3.45,7.93-1.62,.7-2.84,1.06-4.6,1.06"
      />
      <path
        class="cls-478"
        d="M393.75,85.48c2.36,0,4.16-.48,6.33-1.42,5.14-2.22,7.7-8.1,5.83-13.37l-10.64-30.05c-2.33-6.57-8.58-10.99-15.55-10.99h-56.86s0,4.34,0,4.34h56.86c5.14,0,9.74,3.25,11.45,8.1l10.64,30.05c1.11,3.13-.41,6.61-3.46,7.93-1.62,.7-2.84,1.06-4.6,1.06"
      />
      <path
        class="cls-280"
        d="M393.75,85.47c2.36,0,4.16-.48,6.33-1.41,5.13-2.22,7.69-8.09,5.82-13.36l-10.64-30.05c-2.33-6.57-8.57-10.99-15.54-10.99h-56.86s0,4.33,0,4.33h56.86c5.14,0,9.75,3.26,11.46,8.1l10.64,30.05c1.11,3.13-.41,6.62-3.46,7.94-1.62,.7-2.84,1.06-4.61,1.06"
      />
      <path
        class="cls-265"
        d="M393.75,85.47c2.36,0,4.16-.48,6.32-1.41,5.13-2.22,7.69-8.08,5.82-13.35l-10.64-30.05c-2.33-6.57-8.57-10.98-15.54-10.98h-56.86s0,4.32,0,4.32h56.86c5.14,0,9.75,3.26,11.47,8.11l10.64,30.05c1.11,3.14-.41,6.63-3.47,7.95-1.62,.7-2.84,1.06-4.61,1.06"
      />
      <path
        class="cls-281"
        d="M393.75,85.46c2.36,0,4.15-.48,6.32-1.41,5.13-2.22,7.68-8.08,5.82-13.34l-10.64-30.05c-2.32-6.57-8.57-10.98-15.53-10.98h-56.86s0,4.3,0,4.3h56.86c5.15,0,9.76,3.26,11.47,8.11l10.64,30.05c1.11,3.14-.41,6.64-3.47,7.96-1.62,.7-2.84,1.06-4.61,1.06"
      />
      <path
        class="cls-250"
        d="M393.75,85.45c2.36,0,4.15-.48,6.32-1.41,5.12-2.22,7.68-8.07,5.81-13.34l-10.64-30.05c-2.32-6.56-8.56-10.97-15.52-10.97h-56.86s0,4.29,0,4.29h56.86c5.15,0,9.76,3.26,11.48,8.11l10.64,30.05c1.11,3.14-.41,6.64-3.47,7.97-1.63,.7-2.85,1.06-4.62,1.06"
      />
      <path
        class="cls-417"
        d="M393.75,85.45c2.36,0,4.15-.48,6.32-1.41,5.12-2.22,7.67-8.07,5.81-13.33l-10.64-30.05c-2.32-6.56-8.56-10.97-15.52-10.97h-56.86s0,4.28,0,4.28h56.86c5.15,0,9.77,3.26,11.49,8.12l10.64,30.05c1.11,3.15-.41,6.65-3.48,7.98-1.63,.7-2.85,1.06-4.62,1.06"
      />
      <path
        class="cls-236"
        d="M393.75,85.44c2.36,0,4.15-.48,6.31-1.41,5.12-2.21,7.67-8.06,5.81-13.32l-10.64-30.05c-2.32-6.56-8.55-10.96-15.51-10.96h-56.86s0,4.26,0,4.26h56.86c5.15,0,9.77,3.26,11.49,8.12l10.64,30.05c1.12,3.15-.41,6.66-3.48,7.99-1.63,.7-2.85,1.06-4.62,1.06"
      />
      <path
        class="cls-278"
        d="M393.75,85.43c2.36,0,4.15-.47,6.31-1.41,5.11-2.21,7.66-8.06,5.8-13.31l-10.64-30.05c-2.32-6.55-8.55-10.96-15.51-10.96h-56.86s0,4.25,0,4.25h56.86c5.16,0,9.78,3.27,11.5,8.13l10.64,30.05c1.12,3.15-.41,6.66-3.48,7.99-1.63,.7-2.85,1.06-4.62,1.06"
      />
      <path
        class="cls-234"
        d="M393.75,85.43c2.36,0,4.15-.47,6.31-1.41,5.11-2.21,7.66-8.05,5.8-13.3l-10.64-30.05c-2.32-6.55-8.55-10.95-15.5-10.95h-56.86s0,4.23,0,4.23h56.86c5.16,0,9.78,3.27,11.51,8.13l10.64,30.05c1.12,3.16-.41,6.67-3.49,8-1.63,.71-2.85,1.06-4.63,1.06"
      />
      <path
        class="cls-383"
        d="M393.75,85.42c2.36,0,4.15-.47,6.31-1.41,5.11-2.21,7.65-8.05,5.79-13.29l-10.64-30.05c-2.32-6.55-8.54-10.95-15.49-10.95h-56.86s0,4.22,0,4.22h56.86c5.16,0,9.79,3.27,11.51,8.14l10.64,30.05c1.12,3.16-.42,6.68-3.49,8.01-1.63,.71-2.86,1.06-4.63,1.06"
      />
      <path
        class="cls-260"
        d="M393.75,85.41c2.35,0,4.14-.47,6.3-1.41,5.1-2.21,7.65-8.04,5.79-13.28l-10.64-30.05c-2.32-6.55-8.54-10.95-15.49-10.95h-56.86s0,4.21,0,4.21h56.86c5.17,0,9.8,3.27,11.52,8.14l10.64,30.05c1.12,3.16-.42,6.69-3.5,8.02-1.63,.71-2.86,1.06-4.63,1.06"
      />
      <path
        class="cls-275"
        d="M393.75,85.4c2.35,0,4.14-.47,6.3-1.41,5.1-2.21,7.64-8.04,5.79-13.28l-10.64-30.05c-2.32-6.54-8.54-10.94-15.48-10.94h-56.86s0,4.19,0,4.19h56.86c5.17,0,9.8,3.27,11.53,8.15l10.64,30.05c1.12,3.17-.42,6.69-3.5,8.03-1.63,.71-2.86,1.06-4.64,1.06"
      />
      <path
        class="cls-257"
        d="M393.75,85.4c2.35,0,4.14-.47,6.3-1.41,5.1-2.21,7.64-8.03,5.78-13.27l-10.64-30.05c-2.32-6.54-8.53-10.94-15.47-10.94h-56.86s0,4.18,0,4.18h56.86c5.17,0,9.81,3.28,11.53,8.15l10.64,30.05c1.12,3.17-.42,6.7-3.5,8.04-1.63,.71-2.86,1.06-4.64,1.06"
      />
      <path
        class="cls-269"
        d="M393.75,85.39c2.35,0,4.14-.47,6.3-1.41,5.09-2.2,7.63-8.03,5.78-13.26l-10.64-30.05c-2.31-6.54-8.53-10.93-15.47-10.93h-56.86s0,4.17,0,4.17h56.86c5.17,0,9.81,3.28,11.54,8.16l10.64,30.05c1.12,3.17-.42,6.71-3.51,8.05-1.63,.71-2.86,1.07-4.64,1.07"
      />
      <path
        class="cls-242"
        d="M393.75,85.38c2.35,0,4.14-.47,6.29-1.41,5.09-2.2,7.63-8.02,5.78-13.25l-10.64-30.05c-2.31-6.54-8.53-10.93-15.46-10.93h-56.86s0,4.15,0,4.15h56.86c5.18,0,9.82,3.28,11.55,8.16l10.64,30.05c1.12,3.18-.42,6.72-3.51,8.05-1.63,.71-2.87,1.07-4.65,1.07"
      />
      <path
        class="cls-141"
        d="M393.75,85.38c2.35,0,4.14-.47,6.29-1.41,5.09-2.2,7.62-8.02,5.77-13.24l-10.64-30.05c-2.31-6.53-8.52-10.92-15.45-10.92h-56.86s0,4.14,0,4.14h56.86c5.18,0,9.82,3.28,11.55,8.17l10.64,30.05c1.13,3.18-.42,6.72-3.51,8.06-1.64,.71-2.87,1.07-4.65,1.07"
      />
      <path
        class="cls-148"
        d="M393.75,85.37c2.35,0,4.13-.47,6.29-1.41,5.08-2.2,7.62-8.01,5.77-13.23l-10.64-30.05c-2.31-6.53-8.52-10.92-15.45-10.92h-56.86s0,4.12,0,4.12h56.86c5.18,0,9.83,3.28,11.56,8.17l10.64,30.05c1.13,3.18-.42,6.73-3.52,8.07-1.64,.71-2.87,1.07-4.65,1.07"
      />
      <path
        class="cls-191"
        d="M393.75,85.36c2.35,0,4.13-.47,6.29-1.41,5.08-2.2,7.61-8.01,5.76-13.22l-10.64-30.05c-2.31-6.53-8.52-10.91-15.44-10.91h-56.86s0,4.11,0,4.11h56.86c5.19,0,9.83,3.28,11.56,8.17l10.64,30.05c1.13,3.19-.42,6.74-3.52,8.08-1.64,.71-2.87,1.07-4.65,1.07"
      />
      <path
        class="cls-150"
        d="M393.75,85.36c2.35,0,4.13-.47,6.28-1.41,5.08-2.2,7.61-8,5.76-13.22l-10.64-30.05c-2.31-6.52-8.51-10.91-15.43-10.91h-56.86s0,4.1,0,4.1h56.86c5.19,0,9.84,3.29,11.57,8.18l10.64,30.05c1.13,3.19-.42,6.74-3.53,8.09-1.64,.71-2.87,1.07-4.66,1.07"
      />
      <path
        class="cls-153"
        d="M393.75,85.35c2.35,0,4.13-.47,6.28-1.4,5.07-2.2,7.6-8,5.76-13.21l-10.64-30.05c-2.31-6.52-8.51-10.9-15.43-10.9h-56.86s0,4.08,0,4.08h56.86c5.19,0,9.85,3.29,11.58,8.18l10.64,30.05c1.13,3.19-.42,6.75-3.53,8.1-1.64,.71-2.88,1.07-4.66,1.07"
      />
      <path
        class="cls-173"
        d="M393.75,85.34c2.35,0,4.13-.47,6.28-1.4,5.07-2.19,7.6-7.99,5.75-13.2l-10.64-30.05c-2.31-6.52-8.5-10.9-15.42-10.9h-56.86s0,4.07,0,4.07h56.86c5.2,0,9.85,3.29,11.58,8.19l10.64,30.05c1.13,3.2-.42,6.76-3.53,8.11-1.64,.71-2.88,1.07-4.66,1.07"
      />
      <path
        class="cls-200"
        d="M393.75,85.34c2.34,0,4.13-.47,6.28-1.4,5.07-2.19,7.59-7.99,5.75-13.19l-10.64-30.05c-2.31-6.52-8.5-10.9-15.41-10.9h-56.86s0,4.06,0,4.06h56.86c5.2,0,9.86,3.29,11.59,8.19l10.64,30.05c1.13,3.2-.42,6.77-3.54,8.11-1.64,.71-2.88,1.07-4.67,1.07"
      />
      <path
        class="cls-248"
        d="M393.75,85.33c2.34,0,4.12-.47,6.27-1.4,5.06-2.19,7.59-7.98,5.75-13.18l-10.64-30.05c-2.31-6.51-8.5-10.89-15.41-10.89h-56.86s0,4.04,0,4.04h56.86c5.2,0,9.86,3.29,11.6,8.2l10.64,30.05c1.13,3.2-.42,6.77-3.54,8.12-1.64,.71-2.88,1.07-4.67,1.07"
      />
      <path
        class="cls-298"
        d="M393.75,85.32c2.34,0,4.12-.47,6.27-1.4,5.06-2.19,7.58-7.98,5.74-13.17l-10.64-30.05c-2.3-6.51-8.49-10.89-15.4-10.89h-56.86s0,4.03,0,4.03h56.86c5.2,0,9.87,3.3,11.6,8.2l10.64,30.05c1.14,3.21-.42,6.78-3.54,8.13-1.64,.71-2.88,1.07-4.67,1.07"
      />
      <path
        class="cls-303"
        d="M393.75,85.32c2.34,0,4.12-.47,6.27-1.4,5.06-2.19,7.58-7.97,5.74-13.16l-10.64-30.05c-2.3-6.51-8.49-10.88-15.4-10.88h-56.86s0,4.01,0,4.01h56.86c5.21,0,9.87,3.3,11.61,8.21l10.64,30.05c1.14,3.21-.42,6.79-3.55,8.14-1.64,.71-2.89,1.07-4.67,1.07"
      />
      <path
        class="cls-289"
        d="M393.75,85.31c2.34,0,4.12-.47,6.27-1.4,5.05-2.19,7.57-7.97,5.73-13.16l-10.64-30.05c-2.3-6.51-8.49-10.88-15.39-10.88h-56.86s0,4,0,4h56.86c5.21,0,9.88,3.3,11.62,8.21l10.64,30.05c1.14,3.21-.42,6.79-3.55,8.15-1.64,.71-2.89,1.07-4.68,1.07"
      />
      <path
        class="cls-295"
        d="M393.75,85.3c2.34,0,4.12-.47,6.26-1.4,5.05-2.19,7.57-7.96,5.73-13.15l-10.64-30.05c-2.3-6.5-8.48-10.87-15.38-10.87h-56.86s0,3.99,0,3.99h56.86c5.21,0,9.88,3.3,11.62,8.22l10.64,30.05c1.14,3.22-.42,6.8-3.56,8.16-1.64,.71-2.89,1.07-4.68,1.07"
      />
      <path
        class="cls-136"
        d="M393.75,85.29c2.34,0,4.12-.47,6.26-1.4,5.05-2.18,7.56-7.95,5.73-13.14l-10.64-30.05c-2.3-6.5-8.48-10.87-15.38-10.87h-56.86s0,3.97,0,3.97h56.86c5.22,0,9.89,3.3,11.63,8.22l10.64,30.05c1.14,3.22-.42,6.81-3.56,8.17-1.65,.71-2.89,1.07-4.68,1.07"
      />
      <path
        class="cls-350"
        d="M393.75,85.29c2.34,0,4.11-.47,6.26-1.4,5.04-2.18,7.56-7.95,5.72-13.13l-10.64-30.05c-2.3-6.5-8.48-10.86-15.37-10.86h-56.86s0,3.96,0,3.96h56.86c5.22,0,9.89,3.31,11.64,8.22l10.64,30.05c1.14,3.22-.42,6.82-3.56,8.17-1.65,.71-2.89,1.07-4.69,1.07"
      />
      <path
        class="cls-354"
        d="M393.75,85.28c2.34,0,4.11-.47,6.26-1.4,5.04-2.18,7.55-7.94,5.72-13.12l-10.64-30.05c-2.3-6.49-8.47-10.86-15.36-10.86h-56.86s0,3.95,0,3.95h56.86c5.22,0,9.9,3.31,11.64,8.23l10.64,30.05c1.14,3.23-.42,6.82-3.57,8.18-1.65,.71-2.9,1.07-4.69,1.07"
      />
      <path
        class="cls-394"
        d="M393.75,85.27c2.34,0,4.11-.47,6.25-1.4,5.04-2.18,7.55-7.94,5.72-13.11l-10.64-30.05c-2.3-6.49-8.47-10.85-15.36-10.85h-56.86s0,3.93,0,3.93h56.86c5.22,0,9.91,3.31,11.65,8.23l10.64,30.05c1.14,3.23-.42,6.83-3.57,8.19-1.65,.71-2.9,1.07-4.69,1.07"
      />
      <path
        class="cls-397"
        d="M393.75,85.27c2.33,0,4.11-.47,6.25-1.4,5.03-2.18,7.54-7.93,5.71-13.1l-10.64-30.05c-2.3-6.49-8.47-10.85-15.35-10.85h-56.86s0,3.92,0,3.92h56.86c5.23,0,9.91,3.31,11.66,8.24l10.64,30.05c1.14,3.23-.43,6.84-3.57,8.2-1.65,.71-2.9,1.08-4.7,1.08"
      />
      <path
        class="cls-409"
        d="M393.75,85.26c2.33,0,4.11-.47,6.25-1.4,5.03-2.18,7.54-7.93,5.71-13.1l-10.64-30.05c-2.3-6.49-8.46-10.84-15.34-10.84h-56.86s0,3.91,0,3.91h56.86c5.23,0,9.92,3.31,11.66,8.24l10.64,30.05c1.15,3.24-.43,6.84-3.58,8.21-1.65,.71-2.9,1.08-4.7,1.08"
      />
      <path
        class="cls-318"
        d="M393.75,85.25c2.33,0,4.11-.47,6.25-1.4,5.03-2.18,7.53-7.92,5.71-13.09l-10.64-30.05c-2.3-6.48-8.46-10.84-15.34-10.84h-56.86s0,3.89,0,3.89h56.86c5.23,0,9.92,3.31,11.67,8.25l10.64,30.05c1.15,3.24-.43,6.85-3.58,8.22-1.65,.71-2.9,1.08-4.7,1.08"
      />
      <path
        class="cls-316"
        d="M393.75,85.25c2.33,0,4.1-.47,6.24-1.4,5.02-2.17,7.53-7.92,5.7-13.08l-10.64-30.05c-2.29-6.48-8.45-10.84-15.33-10.84h-56.86s0,3.88,0,3.88h56.86c5.24,0,9.93,3.32,11.67,8.25l10.64,30.05c1.15,3.25-.43,6.86-3.59,8.23-1.65,.71-2.91,1.08-4.7,1.08"
      />
      <path
        class="cls-313"
        d="M393.75,85.24c2.33,0,4.1-.47,6.24-1.4,5.02-2.17,7.52-7.91,5.7-13.07l-10.64-30.05c-2.29-6.48-8.45-10.83-15.32-10.83h-56.86s0,3.86,0,3.86h56.86c5.24,0,9.93,3.32,11.68,8.26l10.64,30.05c1.15,3.25-.43,6.87-3.59,8.23-1.65,.72-2.91,1.08-4.71,1.08"
      />
      <path
        class="cls-310"
        d="M393.74,85.23c2.33,0,4.1-.47,6.24-1.39,5.02-2.17,7.52-7.91,5.69-13.06l-10.64-30.05c-2.29-6.48-8.45-10.83-15.32-10.83h-56.86s0,3.85,0,3.85h56.86c5.24,0,9.94,3.32,11.69,8.26l10.64,30.05c1.15,3.25-.43,6.87-3.59,8.24-1.65,.72-2.91,1.08-4.71,1.08"
      />
      <path
        class="cls-226"
        d="M393.74,85.23c2.33,0,4.1-.47,6.24-1.39,5.01-2.17,7.51-7.9,5.69-13.05l-10.64-30.05c-2.29-6.47-8.44-10.82-15.31-10.82h-56.86s0,3.84,0,3.84h56.86c5.24,0,9.94,3.32,11.69,8.27l10.64,30.05c1.15,3.26-.43,6.88-3.6,8.25-1.65,.72-2.91,1.08-4.71,1.08"
      />
      <path
        class="cls-326"
        d="M393.74,85.22c2.33,0,4.1-.47,6.23-1.39,5.01-2.17,7.51-7.9,5.69-13.04l-10.64-30.05c-2.29-6.47-8.44-10.82-15.3-10.82h-56.86s0,3.82,0,3.82h56.86c5.25,0,9.95,3.32,11.7,8.27l10.64,30.05c1.15,3.26-.43,6.89-3.6,8.26-1.66,.72-2.91,1.08-4.72,1.08"
      />
      <path
        class="cls-322"
        d="M393.74,85.21c2.33,0,4.1-.47,6.23-1.39,5.01-2.17,7.5-7.89,5.68-13.04l-10.64-30.05c-2.29-6.47-8.44-10.81-15.3-10.81h-56.86s0,3.81,0,3.81h56.86c5.25,0,9.96,3.33,11.71,8.28l10.64,30.05c1.15,3.26-.43,6.89-3.6,8.27-1.66,.72-2.92,1.08-4.72,1.08"
      />
      <path
        class="cls-346"
        d="M393.74,85.21c2.33,0,4.09-.47,6.23-1.39,5-2.17,7.5-7.89,5.68-13.03l-10.64-30.05c-2.29-6.46-8.43-10.81-15.29-10.81h-56.86s0,3.8,0,3.8h56.86c5.25,0,9.96,3.33,11.71,8.28l10.64,30.05c1.16,3.27-.43,6.9-3.61,8.28-1.66,.72-2.92,1.08-4.72,1.08"
      />
      <path
        class="cls-339"
        d="M393.74,85.2c2.33,0,4.09-.47,6.23-1.39,5-2.16,7.49-7.88,5.68-13.02l-10.64-30.05c-2.29-6.46-8.43-10.8-15.29-10.8h-56.86s0,3.78,0,3.78h56.86c5.26,0,9.97,3.33,11.72,8.28l10.64,30.05c1.16,3.27-.43,6.91-3.61,8.29-1.66,.72-2.92,1.08-4.72,1.08"
      />
      <path
        class="cls-362"
        d="M393.74,85.19c2.32,0,4.09-.47,6.22-1.39,5-2.16,7.49-7.88,5.67-13.01l-10.64-30.05c-2.29-6.46-8.43-10.8-15.28-10.8h-56.86s0,3.77,0,3.77h56.86c5.26,0,9.97,3.33,11.73,8.29l10.64,30.05c1.16,3.27-.43,6.92-3.62,8.29-1.66,.72-2.92,1.08-4.73,1.08"
      />
      <path
        class="cls-413"
        d="M393.74,85.18c2.32,0,4.09-.47,6.22-1.39,4.99-2.16,7.48-7.87,5.67-13l-10.64-30.05c-2.29-6.46-8.42-10.79-15.27-10.79h-56.86s0,3.75,0,3.75h56.86c5.26,0,9.98,3.33,11.73,8.29l10.64,30.05c1.16,3.28-.43,6.92-3.62,8.3-1.66,.72-2.92,1.08-4.73,1.08"
      />
      <path
        class="cls-360"
        d="M393.74,85.18c2.32,0,4.09-.47,6.22-1.39,4.99-2.16,7.48-7.87,5.66-12.99l-10.64-30.05c-2.28-6.45-8.42-10.79-15.27-10.79h-56.86s0,3.74,0,3.74h56.86c5.26,0,9.98,3.33,11.74,8.3l10.64,30.05c1.16,3.28-.43,6.93-3.62,8.31-1.66,.72-2.92,1.08-4.73,1.08"
      />
      <path
        class="cls-388"
        d="M393.74,85.17c2.32,0,4.09-.47,6.22-1.39,4.99-2.16,7.47-7.86,5.66-12.98l-10.64-30.05c-2.28-6.45-8.42-10.79-15.26-10.79h-56.86s0,3.73,0,3.73h56.86c5.27,0,9.99,3.34,11.75,8.3l10.64,30.05c1.16,3.28-.43,6.94-3.63,8.32-1.66,.72-2.93,1.08-4.74,1.08"
      />
      <path
        class="cls-376"
        d="M393.74,85.16c2.32,0,4.08-.47,6.21-1.39,4.98-2.16,7.47-7.86,5.66-12.98l-10.64-30.05c-2.28-6.45-8.41-10.78-15.25-10.78h-56.86s0,3.71,0,3.71h56.86c5.27,0,9.99,3.34,11.75,8.31l10.64,30.05c1.16,3.29-.43,6.94-3.63,8.33-1.66,.72-2.93,1.08-4.74,1.08"
      />
      <path
        class="cls-371"
        d="M393.74,85.16c2.32,0,4.08-.47,6.21-1.39,4.98-2.16,7.46-7.85,5.65-12.97l-10.64-30.05c-2.28-6.45-8.41-10.78-15.25-10.78h-56.86s0,3.7,0,3.7h56.86c5.27,0,10,3.34,11.76,8.31l10.64,30.05c1.16,3.29-.43,6.95-3.63,8.34-1.66,.72-2.93,1.08-4.74,1.08"
      />
      <path
        class="cls-366"
        d="M393.74,85.15c2.32,0,4.08-.47,6.21-1.39,4.98-2.15,7.46-7.85,5.65-12.96l-10.64-30.05c-2.28-6.44-8.4-10.77-15.24-10.77h-56.86s0,3.69,0,3.69h56.86c5.28,0,10,3.34,11.77,8.32l10.64,30.05c1.17,3.29-.43,6.96-3.64,8.35-1.66,.72-2.93,1.09-4.75,1.09"
      />
      <path
        class="cls-332"
        d="M393.74,85.14c2.32,0,4.08-.47,6.21-1.39,4.97-2.15,7.45-7.84,5.65-12.95l-10.64-30.05c-2.28-6.44-8.4-10.77-15.23-10.77h-56.86s0,3.67,0,3.67h56.86c5.28,0,10.01,3.34,11.77,8.32l10.64,30.05c1.17,3.3-.43,6.97-3.64,8.35-1.66,.72-2.93,1.09-4.75,1.09"
      />
      <path
        class="cls-330"
        d="M393.74,85.14c2.32,0,4.08-.47,6.2-1.39,4.97-2.15,7.45-7.84,5.64-12.94l-10.64-30.05c-2.28-6.44-8.4-10.76-15.23-10.76h-56.86s0,3.66,0,3.66h56.86c5.28,0,10.02,3.35,11.78,8.33l10.64,30.05c1.17,3.3-.43,6.97-3.65,8.36-1.67,.72-2.94,1.09-4.75,1.09"
      />
      <path
        class="cls-412"
        d="M393.74,85.13c2.32,0,4.08-.47,6.2-1.39,4.97-2.15,7.44-7.83,5.64-12.93l-10.64-30.05c-2.28-6.43-8.39-10.76-15.22-10.76h-56.86s0,3.64,0,3.64h56.86c5.29,0,10.02,3.35,11.78,8.33l10.64,30.05c1.17,3.3-.43,6.98-3.65,8.37-1.67,.72-2.94,1.09-4.75,1.09"
      />
      <path
        class="cls-400"
        d="M393.74,85.12c2.32,0,4.07-.47,6.2-1.39,4.96-2.15,7.44-7.82,5.63-12.92l-10.64-30.05c-2.28-6.43-8.39-10.75-15.21-10.75h-56.86s0,3.63,0,3.63h56.86c5.29,0,10.03,3.35,11.79,8.33l10.64,30.05c1.17,3.31-.43,6.99-3.65,8.38-1.67,.72-2.94,1.09-4.76,1.09"
      />
      <path
        class="cls-399"
        d="M393.74,85.12c2.31,0,4.07-.47,6.2-1.39,4.96-2.15,7.43-7.82,5.63-12.92l-10.64-30.05c-2.28-6.43-8.39-10.75-15.21-10.75h-56.86s0,3.62,0,3.62h56.86c5.29,0,10.03,3.35,11.8,8.34l10.64,30.05c1.17,3.31-.43,6.99-3.66,8.39-1.67,.72-2.94,1.09-4.76,1.09"
      />
      <path
        class="cls-42"
        d="M393.74,85.11c2.31,0,4.07-.47,6.19-1.38,4.96-2.15,7.43-7.81,5.63-12.91l-10.64-30.05c-2.27-6.43-8.38-10.74-15.2-10.74h-56.86s0,3.6,0,3.6h56.86c5.29,0,10.04,3.35,11.8,8.34l10.64,30.05c1.17,3.31-.44,7-3.66,8.4-1.67,.72-2.94,1.09-4.76,1.09"
      />
      <path
        class="cls-60"
        d="M393.74,85.1c2.31,0,4.07-.47,6.19-1.38,4.95-2.14,7.42-7.81,5.62-12.9l-10.64-30.05c-2.27-6.42-8.38-10.74-15.19-10.74h-56.86s0,3.59,0,3.59h56.86c5.3,0,10.04,3.35,11.81,8.35l10.64,30.05c1.17,3.32-.44,7.01-3.66,8.41-1.67,.72-2.95,1.09-4.77,1.09"
      />
      <path
        class="cls-41"
        d="M393.74,85.1c2.31,0,4.07-.47,6.19-1.38,4.95-2.14,7.42-7.8,5.62-12.89l-10.64-30.05c-2.27-6.42-8.38-10.74-15.19-10.74h-56.86s0,3.58,0,3.58h56.86c5.3,0,10.05,3.36,11.82,8.35l10.64,30.05c1.17,3.32-.44,7.02-3.67,8.41-1.67,.72-2.95,1.09-4.77,1.09"
      />
      <path
        class="cls-39"
        d="M393.74,85.09c2.31,0,4.07-.47,6.19-1.38,4.95-2.14,7.41-7.8,5.62-12.88l-10.64-30.05c-2.27-6.42-8.37-10.73-15.18-10.73h-56.86s0,3.56,0,3.56h56.86c5.3,0,10.05,3.36,11.82,8.36l10.64,30.05c1.18,3.32-.44,7.02-3.67,8.42-1.67,.72-2.95,1.09-4.77,1.09"
      />
      <path
        class="cls-47"
        d="M393.74,85.08c2.31,0,4.06-.47,6.18-1.38,4.94-2.14,7.41-7.79,5.61-12.87l-10.64-30.05c-2.27-6.42-8.37-10.73-15.18-10.73h-56.86s0,3.55,0,3.55h56.86c5.31,0,10.06,3.36,11.83,8.36l10.64,30.05c1.18,3.33-.44,7.03-3.68,8.43-1.67,.72-2.95,1.09-4.77,1.09"
      />
      <path
        class="cls-32"
        d="M393.74,85.08c2.31,0,4.06-.46,6.18-1.38,4.94-2.14,7.4-7.79,5.61-12.86l-10.64-30.05c-2.27-6.41-8.37-10.72-15.17-10.72h-56.86s0,3.53,0,3.53h56.86c5.31,0,10.07,3.36,11.84,8.37l10.64,30.05c1.18,3.33-.44,7.04-3.68,8.44-1.67,.72-2.95,1.09-4.78,1.09"
      />
      <path
        class="cls-28"
        d="M393.74,85.07c2.31,0,4.06-.46,6.18-1.38,4.94-2.14,7.4-7.78,5.6-12.86l-10.64-30.05c-2.27-6.41-8.36-10.72-15.16-10.72h-56.86s0,3.52,0,3.52h56.86c5.31,0,10.07,3.36,11.84,8.37l10.64,30.05c1.18,3.33-.44,7.04-3.68,8.45-1.67,.72-2.96,1.09-4.78,1.09"
      />
      <path
        class="cls-49"
        d="M393.74,85.06c2.31,0,4.06-.46,6.18-1.38,4.93-2.14,7.39-7.78,5.6-12.85l-10.64-30.05c-2.27-6.41-8.36-10.71-15.16-10.71h-56.86s0,3.51,0,3.51h56.86c5.31,0,10.08,3.37,11.85,8.38l10.64,30.05c1.18,3.34-.44,7.05-3.69,8.46-1.68,.72-2.96,1.09-4.78,1.09"
      />
      <path
        class="cls-27"
        d="M393.74,85.05c2.31,0,4.06-.46,6.17-1.38,4.93-2.13,7.39-7.77,5.6-12.84l-10.64-30.05c-2.27-6.4-8.36-10.71-15.15-10.71h-56.86s0,3.49,0,3.49h56.86c5.32,0,10.08,3.37,11.86,8.38l10.64,30.05c1.18,3.34-.44,7.06-3.69,8.47-1.68,.73-2.96,1.09-4.79,1.09"
      />
      <path
        class="cls-57"
        d="M393.74,85.05c2.3,0,4.06-.46,6.17-1.38,4.93-2.13,7.38-7.77,5.59-12.83l-10.64-30.05c-2.27-6.4-8.35-10.7-15.14-10.7h-56.86s0,3.48,0,3.48h56.86c5.32,0,10.09,3.37,11.86,8.38l10.64,30.05c1.18,3.34-.44,7.07-3.69,8.47-1.68,.73-2.96,1.09-4.79,1.09"
      />
      <path
        class="cls-48"
        d="M393.74,85.04c2.3,0,4.05-.46,6.17-1.38,4.92-2.13,7.38-7.76,5.59-12.82l-10.64-30.05c-2.27-6.4-8.35-10.7-15.14-10.7h-56.86s0,3.47,0,3.47h56.86c5.32,0,10.09,3.37,11.87,8.39l10.64,30.05c1.18,3.35-.44,7.07-3.7,8.48-1.68,.73-2.96,1.09-4.79,1.09"
      />
      <path
        class="cls-10"
        d="M393.74,85.03c2.3,0,4.05-.46,6.17-1.38,4.92-2.13,7.37-7.76,5.59-12.81l-10.64-30.05c-2.26-6.4-8.34-10.69-15.13-10.69h-56.86s0,3.45,0,3.45h56.86c5.33,0,10.1,3.37,11.88,8.39l10.64,30.05c1.19,3.35-.44,7.08-3.7,8.49-1.68,.73-2.97,1.09-4.8,1.09"
      />
      <path
        class="cls-5"
        d="M393.74,85.03c2.3,0,4.05-.46,6.16-1.38,4.92-2.13,7.37-7.75,5.58-12.8l-10.64-30.05c-2.26-6.39-8.34-10.69-15.12-10.69h-56.86s0,3.44,0,3.44h56.86c5.33,0,10.1,3.37,11.88,8.4l10.64,30.05c1.19,3.35-.44,7.09-3.71,8.5-1.68,.73-2.97,1.1-4.8,1.1"
      />
      <path
        class="cls-37"
        d="M393.74,85.02c2.3,0,4.05-.46,6.16-1.38,4.91-2.13,7.36-7.75,5.58-12.8l-10.64-30.05c-2.26-6.39-8.34-10.68-15.12-10.68h-56.86s0,3.42,0,3.42h56.86c5.33,0,10.11,3.38,11.89,8.4l10.64,30.05c1.19,3.36-.44,7.09-3.71,8.51-1.68,.73-2.97,1.1-4.8,1.1"
      />
      <path
        class="cls-6"
        d="M393.74,85.01c2.3,0,4.05-.46,6.16-1.38,4.91-2.13,7.36-7.74,5.57-12.79l-10.64-30.05c-2.26-6.39-8.33-10.68-15.11-10.68h-56.86s0,3.41,0,3.41h56.86c5.33,0,10.11,3.38,11.89,8.41l10.64,30.05c1.19,3.36-.44,7.1-3.71,8.52-1.68,.73-2.97,1.1-4.8,1.1"
      />
      <path
        class="cls-8"
        d="M393.74,85.01c2.3,0,4.05-.46,6.16-1.38,4.91-2.12,7.35-7.74,5.57-12.78l-10.64-30.05c-2.26-6.39-8.33-10.68-15.1-10.68h-56.86s0,3.4,0,3.4h56.86c5.34,0,10.12,3.38,11.9,8.41l10.64,30.05c1.19,3.36-.44,7.11-3.72,8.53-1.68,.73-2.97,1.1-4.81,1.1"
      />
      <path
        class="cls-12"
        d="M393.74,85c2.3,0,4.04-.46,6.15-1.38,4.9-2.12,7.35-7.73,5.57-12.77l-10.64-30.05c-2.26-6.38-8.33-10.67-15.1-10.67h-56.86s0,3.38,0,3.38h56.86c5.34,0,10.13,3.38,11.91,8.42l10.64,30.05c1.19,3.37-.44,7.12-3.72,8.53-1.68,.73-2.98,1.1-4.81,1.1"
      />
      <path
        class="cls-53"
        d="M393.74,84.99c2.3,0,4.04-.46,6.15-1.38,4.9-2.12,7.35-7.73,5.56-12.76l-10.64-30.05c-2.26-6.38-8.32-10.67-15.09-10.67h-56.86s0,3.37,0,3.37h56.86c5.34,0,10.13,3.38,11.91,8.42l10.64,30.05c1.19,3.37-.44,7.12-3.72,8.54-1.68,.73-2.98,1.1-4.81,1.1"
      />
      <path
        class="cls-55"
        d="M393.74,84.99c2.3,0,4.04-.46,6.15-1.37,4.9-2.12,7.34-7.72,5.56-12.75l-10.64-30.05c-2.26-6.38-8.32-10.66-15.08-10.66h-56.86s0,3.36,0,3.36h56.86c5.35,0,10.14,3.39,11.92,8.43l10.64,30.05c1.19,3.37-.44,7.13-3.73,8.55-1.68,.73-2.98,1.1-4.82,1.1"
      />
      <path
        class="cls-61"
        d="M393.74,84.98c2.3,0,4.04-.46,6.15-1.37,4.89-2.12,7.34-7.72,5.56-12.74l-10.64-30.05c-2.26-6.37-8.32-10.66-15.08-10.66h-56.86s0,3.34,0,3.34h56.86c5.35,0,10.14,3.39,11.93,8.43l10.64,30.05c1.2,3.38-.44,7.14-3.73,8.56-1.69,.73-2.98,1.1-4.82,1.1"
      />
      <path
        class="cls-51"
        d="M393.74,84.97c2.29,0,4.04-.46,6.14-1.37,4.89-2.12,7.33-7.71,5.55-12.74l-10.64-30.05c-2.26-6.37-8.31-10.65-15.07-10.65h-56.86s0,3.33,0,3.33h56.86c5.35,0,10.15,3.39,11.93,8.44l10.64,30.05c1.2,3.38-.44,7.14-3.73,8.57-1.69,.73-2.98,1.1-4.82,1.1"
      />
      <path
        class="cls-2"
        d="M393.74,84.97c2.29,0,4.04-.46,6.14-1.37,4.89-2.12,7.33-7.71,5.55-12.73l-10.64-30.05c-2.25-6.37-8.31-10.65-15.07-10.65h-56.86s0,3.32,0,3.32h56.86c5.35,0,10.15,3.39,11.94,8.44l10.64,30.05c1.2,3.38-.44,7.15-3.74,8.58-1.69,.73-2.99,1.1-4.82,1.1"
      />
    </g>
    <g>
      <path
        class="cls-2"
        d="M393.74,85.05c2.29,0,4.52-.46,6.63-1.37,4.89-2.12,7.32-7.71,5.55-12.73l-10.64-30.05c-2.25-6.37-8.31-10.65-15.07-10.65h-56.86v3.32h56.86c5.35,0,10.15,3.39,11.94,8.44l10.64,30.05c1.2,3.38-.44,7.15-3.74,8.58-1.69,.73-3.47,1.1-5.31,1.1"
      />
      <path
        class="cls-54"
        d="M393.74,85.04c2.29,0,4.52-.46,6.63-1.37,4.88-2.11,7.32-7.7,5.54-12.72l-10.64-30.05c-2.25-6.37-8.31-10.64-15.06-10.64h-56.86v3.3h56.86c5.36,0,10.16,3.39,11.95,8.44l10.64,30.05c1.2,3.39-.45,7.16-3.74,8.59-1.69,.73-3.48,1.1-5.31,1.1"
      />
      <path
        class="cls-38"
        d="M393.74,85.04c2.29,0,4.52-.46,6.62-1.37,4.88-2.11,7.32-7.7,5.54-12.71l-10.64-30.05c-2.25-6.36-8.3-10.64-15.05-10.64h-56.86v3.29h56.86c5.36,0,10.16,3.39,11.95,8.45l10.64,30.05c1.2,3.39-.45,7.16-3.75,8.59-1.69,.73-3.48,1.1-5.32,1.1"
      />
      <path
        class="cls-52"
        d="M393.74,85.03c2.29,0,4.52-.46,6.62-1.37,4.88-2.11,7.31-7.69,5.54-12.7l-10.64-30.05c-2.25-6.36-8.3-10.64-15.05-10.64h-56.86v3.28h56.86c5.36,0,10.17,3.4,11.96,8.45l10.64,30.05c1.2,3.39-.45,7.17-3.75,8.6-1.69,.73-3.48,1.1-5.32,1.1"
      />
      <path
        class="cls-11"
        d="M393.74,85.03c2.29,0,4.52-.46,6.62-1.37,4.88-2.11,7.31-7.69,5.53-12.7l-10.64-30.05c-2.25-6.36-8.3-10.63-15.04-10.63h-56.86v3.27h56.86c5.37,0,10.17,3.4,11.96,8.46l10.64,30.05c1.2,3.4-.45,7.18-3.75,8.61-1.69,.73-3.48,1.1-5.32,1.1"
      />
      <path
        class="cls-13"
        d="M393.74,85.02c2.29,0,4.52-.46,6.62-1.37,4.87-2.11,7.3-7.68,5.53-12.69l-10.64-30.05c-2.25-6.36-8.29-10.63-15.04-10.63h-56.86v3.26h56.86c5.37,0,10.18,3.4,11.97,8.46l10.64,30.05c1.2,3.4-.45,7.18-3.76,8.62-1.69,.73-3.48,1.1-5.32,1.1"
      />
      <path
        class="cls-7"
        d="M393.74,85.01c2.29,0,4.51-.46,6.61-1.37,4.87-2.11,7.3-7.68,5.53-12.68l-10.64-30.05c-2.25-6.35-8.29-10.62-15.03-10.62h-56.86v3.24h56.86c5.37,0,10.18,3.4,11.97,8.46l10.64,30.05c1.2,3.4-.45,7.19-3.76,8.62-1.69,.73-3.48,1.1-5.33,1.1"
      />
      <path
        class="cls-36"
        d="M393.74,85.01c2.29,0,4.51-.46,6.61-1.37,4.87-2.11,7.29-7.67,5.52-12.67l-10.64-30.05c-2.25-6.35-8.29-10.62-15.03-10.62h-56.86v3.23h56.86c5.37,0,10.19,3.4,11.98,8.47l10.64,30.05c1.21,3.4-.45,7.2-3.76,8.63-1.69,.73-3.49,1.1-5.33,1.1"
      />
      <path
        class="cls-5"
        d="M393.74,85c2.29,0,4.51-.46,6.61-1.37,4.86-2.11,7.29-7.67,5.52-12.67l-10.64-30.05c-2.25-6.35-8.28-10.62-15.02-10.62h-56.86v3.22h56.86c5.38,0,10.19,3.4,11.99,8.47l10.64,30.05c1.21,3.41-.45,7.2-3.77,8.64-1.69,.73-3.49,1.1-5.33,1.1"
      />
      <path
        class="cls-9"
        d="M393.74,85c2.29,0,4.51-.46,6.61-1.37,4.86-2.1,7.29-7.66,5.52-12.66l-10.64-30.05c-2.25-6.35-8.28-10.61-15.01-10.61h-56.86v3.21h56.86c5.38,0,10.2,3.41,11.99,8.48l10.64,30.05c1.21,3.41-.45,7.21-3.77,8.65-1.69,.73-3.49,1.1-5.33,1.1"
      />
      <path
        class="cls-29"
        d="M393.74,84.99c2.29,0,4.51-.46,6.6-1.37,4.86-2.1,7.28-7.66,5.51-12.65l-10.64-30.05c-2.25-6.35-8.28-10.61-15.01-10.61h-56.86v3.19h56.86c5.38,0,10.2,3.41,12,8.48l10.64,30.05c1.21,3.41-.45,7.21-3.77,8.65-1.69,.73-3.49,1.11-5.34,1.11"
      />
      <path
        class="cls-58"
        d="M393.74,84.98c2.28,0,4.51-.46,6.6-1.37,4.86-2.1,7.28-7.66,5.51-12.64l-10.64-30.05c-2.25-6.34-8.27-10.6-15-10.6h-56.86v3.18h56.86c5.38,0,10.21,3.41,12,8.48l10.64,30.05c1.21,3.42-.45,7.22-3.78,8.66-1.7,.73-3.49,1.11-5.34,1.11"
      />
      <path
        class="cls-46"
        d="M393.74,84.98c2.28,0,4.5-.46,6.6-1.37,4.85-2.1,7.27-7.65,5.51-12.64l-10.64-30.05c-2.24-6.34-8.27-10.6-15-10.6h-56.86v3.17h56.86c5.39,0,10.21,3.41,12.01,8.49l10.64,30.05c1.21,3.42-.45,7.23-3.78,8.67-1.7,.73-3.49,1.11-5.34,1.11"
      />
      <path
        class="cls-50"
        d="M393.74,84.97c2.28,0,4.5-.46,6.6-1.37,4.85-2.1,7.27-7.65,5.51-12.63l-10.64-30.05c-2.24-6.34-8.27-10.6-14.99-10.6h-56.86v3.16h56.86c5.39,0,10.22,3.41,12.01,8.49l10.64,30.05c1.21,3.42-.45,7.23-3.78,8.68-1.7,.73-3.49,1.11-5.34,1.11"
      />
      <path
        class="cls-33"
        d="M393.74,84.97c2.28,0,4.5-.46,6.6-1.37,4.85-2.1,7.26-7.64,5.5-12.62l-10.64-30.05c-2.24-6.34-8.27-10.59-14.99-10.59h-56.86v3.15h56.86c5.39,0,10.22,3.41,12.02,8.5l10.64,30.05c1.21,3.43-.45,7.24-3.79,8.68-1.7,.73-3.5,1.11-5.34,1.11"
      />
      <path
        class="cls-34"
        d="M393.74,84.96c2.28,0,4.5-.46,6.59-1.37,4.84-2.1,7.26-7.64,5.5-12.61l-10.64-30.05c-2.24-6.33-8.26-10.59-14.98-10.59h-56.86v3.13h56.86c5.39,0,10.23,3.42,12.02,8.5l10.64,30.05c1.21,3.43-.45,7.25-3.79,8.69-1.7,.74-3.5,1.11-5.35,1.11"
      />
      <path
        class="cls-39"
        d="M393.74,84.95c2.28,0,4.5-.46,6.59-1.37,4.84-2.1,7.25-7.63,5.5-12.61l-10.64-30.05c-2.24-6.33-8.26-10.58-14.97-10.58h-56.86v3.12h56.86c5.4,0,10.23,3.42,12.03,8.5l10.64,30.05c1.21,3.43-.45,7.25-3.79,8.7-1.7,.74-3.5,1.11-5.35,1.11"
      />
      <path
        class="cls-41"
        d="M393.74,84.95c2.28,0,4.5-.46,6.59-1.36,4.84-2.09,7.25-7.63,5.49-12.6l-10.64-30.05c-2.24-6.33-8.26-10.58-14.97-10.58h-56.86v3.11h56.86c5.4,0,10.24,3.42,12.04,8.51l10.64,30.05c1.22,3.43-.45,7.26-3.79,8.71-1.7,.74-3.5,1.11-5.35,1.11"
      />
      <path
        class="cls-60"
        d="M393.74,84.94c2.28,0,4.49-.46,6.59-1.36,4.84-2.09,7.25-7.62,5.49-12.59l-10.64-30.05c-2.24-6.33-8.25-10.58-14.96-10.58h-56.86v3.1h56.86c5.4,0,10.24,3.42,12.04,8.51l10.64,30.05c1.22,3.44-.45,7.26-3.8,8.71-1.7,.74-3.5,1.11-5.35,1.11"
      />
      <path
        class="cls-43"
        d="M393.74,84.94c2.28,0,4.49-.46,6.58-1.36,4.83-2.09,7.24-7.62,5.49-12.58l-10.64-30.05c-2.24-6.32-8.25-10.57-14.96-10.57h-56.86v3.09h56.86c5.4,0,10.24,3.42,12.05,8.52l10.64,30.05c1.22,3.44-.45,7.27-3.8,8.72-1.7,.74-3.5,1.11-5.36,1.11"
      />
      <path
        class="cls-402"
        d="M393.74,84.93c2.28,0,4.49-.46,6.58-1.36,4.83-2.09,7.24-7.61,5.48-12.58l-10.64-30.05c-2.24-6.32-8.25-10.57-14.95-10.57h-56.86v3.07h56.86c5.41,0,10.25,3.42,12.05,8.52l10.64,30.05c1.22,3.44-.45,7.28-3.8,8.73-1.7,.74-3.51,1.11-5.36,1.11"
      />
      <path
        class="cls-381"
        d="M393.74,84.92c2.28,0,4.49-.46,6.58-1.36,4.83-2.09,7.23-7.61,5.48-12.57l-10.64-30.05c-2.24-6.32-8.24-10.56-14.95-10.56h-56.86v3.06h56.86c5.41,0,10.25,3.43,12.06,8.52l10.64,30.05c1.22,3.45-.45,7.28-3.81,8.74-1.7,.74-3.51,1.11-5.36,1.11"
      />
      <path
        class="cls-331"
        d="M393.74,84.92c2.28,0,4.49-.46,6.58-1.36,4.82-2.09,7.23-7.61,5.48-12.56l-10.64-30.05c-2.24-6.32-8.24-10.56-14.94-10.56h-56.86v3.05h56.86c5.41,0,10.26,3.43,12.06,8.53l10.64,30.05c1.22,3.45-.45,7.29-3.81,8.74-1.7,.74-3.51,1.11-5.36,1.11"
      />
      <path
        class="cls-332"
        d="M393.74,84.91c2.27,0,4.49-.46,6.57-1.36,4.82-2.09,7.22-7.6,5.47-12.55l-10.64-30.05c-2.24-6.31-8.24-10.56-14.94-10.56h-56.86v3.04h56.86c5.41,0,10.26,3.43,12.07,8.53l10.64,30.05c1.22,3.45-.45,7.3-3.81,8.75-1.7,.74-3.51,1.11-5.37,1.11"
      />
      <path
        class="cls-366"
        d="M393.74,84.91c2.27,0,4.48-.46,6.57-1.36,4.82-2.09,7.22-7.6,5.47-12.55l-10.64-30.05c-2.23-6.31-8.23-10.55-14.93-10.55h-56.86v3.03h56.86c5.42,0,10.27,3.43,12.08,8.54l10.64,30.05c1.22,3.46-.45,7.3-3.82,8.76-1.71,.74-3.51,1.11-5.37,1.11"
      />
      <path
        class="cls-371"
        d="M393.74,84.9c2.27,0,4.48-.46,6.57-1.36,4.82-2.08,7.22-7.59,5.47-12.54l-10.64-30.05c-2.23-6.31-8.23-10.55-14.92-10.55h-56.86v3.01h56.86c5.42,0,10.27,3.43,12.08,8.54l10.64,30.05c1.22,3.46-.45,7.31-3.82,8.77-1.71,.74-3.51,1.11-5.37,1.11"
      />
      <path
        class="cls-374"
        d="M393.74,84.89c2.27,0,4.48-.46,6.57-1.36,4.81-2.08,7.21-7.59,5.46-12.53l-10.64-30.05c-2.23-6.31-8.23-10.54-14.92-10.54h-56.86v3h56.86c5.42,0,10.28,3.43,12.09,8.54l10.64,30.05c1.23,3.46-.45,7.31-3.82,8.77-1.71,.74-3.51,1.11-5.37,1.11"
      />
      <path
        class="cls-386"
        d="M393.74,84.89c2.27,0,4.48-.46,6.56-1.36,4.81-2.08,7.21-7.58,5.46-12.52l-10.64-30.05c-2.23-6.3-8.22-10.54-14.91-10.54h-56.86v2.99h56.86c5.42,0,10.28,3.43,12.09,8.55l10.64,30.05c1.23,3.46-.46,7.32-3.83,8.78-1.71,.74-3.52,1.11-5.38,1.11"
      />
      <path
        class="cls-359"
        d="M393.74,84.88c2.27,0,4.48-.46,6.56-1.36,4.81-2.08,7.2-7.58,5.46-12.52l-10.64-30.05c-2.23-6.3-8.22-10.54-14.91-10.54h-56.86v2.98h56.86c5.43,0,10.29,3.44,12.1,8.55l10.64,30.05c1.23,3.47-.46,7.33-3.83,8.79-1.71,.74-3.52,1.11-5.38,1.11"
      />
      <path
        class="cls-361"
        d="M393.74,84.88c2.27,0,4.48-.46,6.56-1.36,4.8-2.08,7.2-7.57,5.45-12.51l-10.64-30.05c-2.23-6.3-8.22-10.53-14.9-10.53h-56.86v2.97h56.86c5.43,0,10.29,3.44,12.1,8.56l10.64,30.05c1.23,3.47-.46,7.33-3.83,8.8-1.71,.74-3.52,1.11-5.38,1.11"
      />
      <path
        class="cls-368"
        d="M393.74,84.87c2.27,0,4.48-.46,6.56-1.36,4.8-2.08,7.19-7.57,5.45-12.5l-10.64-30.05c-2.23-6.3-8.22-10.53-14.9-10.53h-56.86v2.95h56.86c5.43,0,10.3,3.44,12.11,8.56l10.64,30.05c1.23,3.47-.46,7.34-3.84,8.8-1.71,.74-3.52,1.12-5.38,1.12"
      />
      <path
        class="cls-346"
        d="M393.74,84.86c2.27,0,4.47-.46,6.55-1.36,4.8-2.08,7.19-7.56,5.45-12.49l-10.64-30.05c-2.23-6.29-8.21-10.52-14.89-10.52h-56.86v2.94h56.86c5.43,0,10.3,3.44,12.12,8.56l10.64,30.05c1.23,3.48-.46,7.35-3.84,8.81-1.71,.74-3.52,1.12-5.39,1.12"
      />
      <path
        class="cls-324"
        d="M393.74,84.86c2.27,0,4.47-.46,6.55-1.36,4.8-2.08,7.19-7.56,5.44-12.49l-10.64-30.05c-2.23-6.29-8.21-10.52-14.88-10.52h-56.86v2.93h56.86c5.44,0,10.31,3.44,12.12,8.57l10.64,30.05c1.23,3.48-.46,7.35-3.84,8.82-1.71,.74-3.52,1.12-5.39,1.12"
      />
      <path
        class="cls-347"
        d="M393.74,84.85c2.27,0,4.47-.46,6.55-1.36,4.79-2.07,7.18-7.56,5.44-12.48l-10.64-30.05c-2.23-6.29-8.21-10.52-14.88-10.52h-56.86v2.92h56.86c5.44,0,10.31,3.44,12.13,8.57l10.64,30.05c1.23,3.48-.46,7.36-3.85,8.83-1.71,.74-3.53,1.12-5.39,1.12"
      />
      <path
        class="cls-226"
        d="M393.74,84.85c2.27,0,4.47-.46,6.55-1.36,4.79-2.07,7.18-7.55,5.44-12.47l-10.64-30.05c-2.23-6.29-8.2-10.51-14.87-10.51h-56.86v2.91h56.86c5.44,0,10.32,3.45,12.13,8.58l10.64,30.05c1.23,3.48-.46,7.36-3.85,8.83-1.71,.74-3.53,1.12-5.39,1.12"
      />
      <path
        class="cls-307"
        d="M393.74,84.84c2.26,0,4.47-.46,6.55-1.36,4.79-2.07,7.17-7.55,5.43-12.46l-10.64-30.05c-2.23-6.29-8.2-10.51-14.87-10.51h-56.86v2.89h56.86c5.44,0,10.32,3.45,12.14,8.58l10.64,30.05c1.23,3.49-.46,7.37-3.85,8.84-1.71,.74-3.53,1.12-5.4,1.12"
      />
      <path
        class="cls-311"
        d="M393.74,84.83c2.26,0,4.47-.46,6.54-1.36,4.78-2.07,7.17-7.54,5.43-12.46l-10.64-30.05c-2.22-6.28-8.2-10.5-14.86-10.5h-56.86v2.88h56.86c5.45,0,10.33,3.45,12.14,8.58l10.64,30.05c1.24,3.49-.46,7.38-3.86,8.85-1.71,.74-3.53,1.12-5.4,1.12"
      />
      <path
        class="cls-319"
        d="M393.74,84.83c2.26,0,4.46-.46,6.54-1.35,4.78-2.07,7.16-7.54,5.43-12.45l-10.64-30.05c-2.22-6.28-8.19-10.5-14.86-10.5h-56.86v2.87h56.86c5.45,0,10.33,3.45,12.15,8.59l10.64,30.05c1.24,3.49-.46,7.38-3.86,8.86-1.72,.74-3.53,1.12-5.4,1.12"
      />
      <path
        class="cls-406"
        d="M393.74,84.82c2.26,0,4.46-.46,6.54-1.35,4.78-2.07,7.16-7.53,5.42-12.44l-10.64-30.05c-2.22-6.28-8.19-10.5-14.85-10.5h-56.86v2.86h56.86c5.45,0,10.34,3.45,12.16,8.59l10.64,30.05c1.24,3.5-.46,7.39-3.86,8.86-1.72,.74-3.53,1.12-5.4,1.12"
      />
      <path
        class="cls-408"
        d="M393.74,84.82c2.26,0,4.46-.46,6.54-1.35,4.78-2.07,7.16-7.53,5.42-12.43l-10.64-30.05c-2.22-6.28-8.19-10.49-14.84-10.49h-56.86v2.85h56.86c5.45,0,10.34,3.45,12.16,8.6l10.64,30.05c1.24,3.5-.46,7.4-3.87,8.87-1.72,.74-3.54,1.12-5.4,1.12"
      />
      <path
        class="cls-394"
        d="M393.74,84.81c2.26,0,4.46-.46,6.53-1.35,4.77-2.07,7.15-7.52,5.42-12.43l-10.64-30.05c-2.22-6.27-8.18-10.49-14.84-10.49h-56.86v2.83h56.86c5.46,0,10.35,3.46,12.17,8.6l10.64,30.05c1.24,3.5-.46,7.4-3.87,8.88-1.72,.74-3.54,1.12-5.41,1.12"
      />
      <path
        class="cls-354"
        d="M393.74,84.8c2.26,0,4.46-.46,6.53-1.35,4.77-2.06,7.15-7.52,5.41-12.42l-10.64-30.05c-2.22-6.27-8.18-10.48-14.83-10.48h-56.86v2.82h56.86c5.46,0,10.35,3.46,12.17,8.6l10.64,30.05c1.24,3.51-.46,7.41-3.87,8.89-1.72,.74-3.54,1.12-5.41,1.12"
      />
      <path
        class="cls-350"
        d="M393.74,84.8c2.26,0,4.46-.45,6.53-1.35,4.77-2.06,7.14-7.51,5.41-12.41l-10.64-30.05c-2.22-6.27-8.18-10.48-14.83-10.48h-56.86v2.81h56.86c5.46,0,10.36,3.46,12.18,8.61l10.64,30.05c1.24,3.51-.46,7.42-3.88,8.89-1.72,.74-3.54,1.12-5.41,1.12"
      />
      <path
        class="cls-137"
        d="M393.74,84.79c2.26,0,4.45-.45,6.53-1.35,4.76-2.06,7.14-7.51,5.41-12.4l-10.64-30.05c-2.22-6.27-8.17-10.48-14.82-10.48h-56.86v2.8h56.86c5.46,0,10.36,3.46,12.18,8.61l10.64,30.05c1.24,3.51-.46,7.42-3.88,8.9-1.72,.74-3.54,1.12-5.41,1.12"
      />
      <path
        class="cls-296"
        d="M393.74,84.79c2.26,0,4.45-.45,6.52-1.35,4.76-2.06,7.13-7.51,5.4-12.4l-10.64-30.05c-2.22-6.26-8.17-10.47-14.82-10.47h-56.86v2.79h56.86c5.47,0,10.37,3.46,12.19,8.62l10.64,30.05c1.24,3.51-.46,7.43-3.88,8.91-1.72,.74-3.54,1.12-5.42,1.12"
      />
      <path
        class="cls-290"
        d="M393.74,84.78c2.26,0,4.45-.45,6.52-1.35,4.76-2.06,7.13-7.5,5.4-12.39l-10.64-30.05c-2.22-6.26-8.17-10.47-14.81-10.47h-56.86v2.77h56.86c5.47,0,10.37,3.46,12.19,8.62l10.64,30.05c1.25,3.52-.46,7.43-3.89,8.92-1.72,.75-3.54,1.12-5.42,1.12"
      />
      <path
        class="cls-298"
        d="M393.74,84.77c2.26,0,4.45-.45,6.52-1.35,4.75-2.06,7.13-7.5,5.4-12.38l-10.64-30.05c-2.22-6.26-8.17-10.46-14.8-10.46h-56.86v2.76h56.86c5.47,0,10.37,3.47,12.2,8.62l10.64,30.05c1.25,3.52-.46,7.44-3.89,8.92-1.72,.75-3.55,1.12-5.42,1.12"
      />
      <path
        class="cls-279"
        d="M393.74,84.77c2.25,0,4.45-.45,6.52-1.35,4.75-2.06,7.12-7.49,5.39-12.37l-10.64-30.05c-2.21-6.26-8.16-10.46-14.8-10.46h-56.86v2.75h56.86c5.47,0,10.38,3.47,12.21,8.63l10.64,30.05c1.25,3.52-.46,7.45-3.89,8.93-1.72,.75-3.55,1.12-5.42,1.12"
      />
      <path
        class="cls-249"
        d="M393.74,84.76c2.25,0,4.45-.45,6.51-1.35,4.75-2.06,7.12-7.49,5.39-12.37l-10.64-30.05c-2.21-6.25-8.16-10.46-14.79-10.46h-56.86v2.74h56.86c5.48,0,10.38,3.47,12.21,8.63l10.64,30.05c1.25,3.53-.46,7.45-3.9,8.94-1.72,.75-3.55,1.12-5.43,1.12"
      />
      <path
        class="cls-173"
        d="M393.74,84.76c2.25,0,4.44-.45,6.51-1.35,4.75-2.05,7.11-7.48,5.39-12.36l-10.64-30.05c-2.21-6.25-8.16-10.45-14.79-10.45h-56.86v2.73h56.86c5.48,0,10.39,3.47,12.22,8.64l10.64,30.05c1.25,3.53-.46,7.46-3.9,8.95-1.72,.75-3.55,1.12-5.43,1.12"
      />
      <path
        class="cls-153"
        d="M393.74,84.75c2.25,0,4.44-.45,6.51-1.35,4.74-2.05,7.11-7.48,5.38-12.35l-10.64-30.05c-2.21-6.25-8.15-10.45-14.78-10.45h-56.86v2.71h56.86c5.48,0,10.39,3.47,12.22,8.64l10.64,30.05c1.25,3.53-.46,7.47-3.9,8.95-1.73,.75-3.55,1.13-5.43,1.13"
      />
      <path
        class="cls-151"
        d="M393.74,84.74c2.25,0,4.44-.45,6.51-1.35,4.74-2.05,7.1-7.47,5.38-12.34l-10.64-30.05c-2.21-6.25-8.15-10.44-14.78-10.44h-56.86v2.7h56.86c5.48,0,10.4,3.47,12.23,8.64l10.64,30.05c1.25,3.54-.46,7.47-3.91,8.96-1.73,.75-3.55,1.13-5.43,1.13"
      />
      <path
        class="cls-149"
        d="M393.74,84.74c2.25,0,4.44-.45,6.5-1.35,4.74-2.05,7.1-7.47,5.38-12.34l-10.64-30.05c-2.21-6.24-8.15-10.44-14.77-10.44h-56.86v2.69h56.86c5.49,0,10.4,3.48,12.23,8.65l10.64,30.05c1.25,3.54-.46,7.48-3.91,8.97-1.73,.75-3.56,1.13-5.44,1.13"
      />
      <path
        class="cls-140"
        d="M393.74,84.73c2.25,0,4.44-.45,6.5-1.35,4.73-2.05,7.09-7.46,5.37-12.33l-10.64-30.05c-2.21-6.24-8.14-10.44-14.77-10.44h-56.86v2.68h56.86c5.49,0,10.41,3.48,12.24,8.65l10.64,30.05c1.25,3.54-.47,7.48-3.91,8.98-1.73,.75-3.56,1.13-5.44,1.13"
      />
      <path
        class="cls-182"
        d="M393.74,84.73c2.25,0,4.44-.45,6.5-1.35,4.73-2.05,7.09-7.46,5.37-12.32l-10.64-30.05c-2.21-6.24-8.14-10.43-14.76-10.43h-56.86v2.67h56.86c5.49,0,10.41,3.48,12.25,8.66l10.64,30.05c1.25,3.54-.47,7.49-3.92,8.98-1.73,.75-3.56,1.13-5.44,1.13"
      />
      <path
        class="cls-241"
        d="M393.74,84.72c2.25,0,4.43-.45,6.5-1.35,4.73-2.05,7.09-7.46,5.37-12.31l-10.64-30.05c-2.21-6.24-8.14-10.43-14.75-10.43h-56.86v2.65h56.86c5.49,0,10.42,3.48,12.25,8.66l10.64,30.05c1.26,3.55-.47,7.5-3.92,8.99-1.73,.75-3.56,1.13-5.44,1.13"
      />
      <path
        class="cls-257"
        d="M393.74,84.71c2.25,0,4.43-.45,6.5-1.35,4.73-2.05,7.08-7.45,5.36-12.31l-10.64-30.05c-2.21-6.23-8.13-10.42-14.75-10.42h-56.86v2.64h56.86c5.5,0,10.42,3.48,12.26,8.66l10.64,30.05c1.26,3.55-.47,7.5-3.92,9-1.73,.75-3.56,1.13-5.45,1.13"
      />
      <path
        class="cls-276"
        d="M393.74,84.71c2.25,0,4.43-.45,6.49-1.34,4.72-2.04,7.08-7.45,5.36-12.3l-10.64-30.05c-2.21-6.23-8.13-10.42-14.74-10.42h-56.86v2.63h56.86c5.5,0,10.43,3.48,12.26,8.67l10.64,30.05c1.26,3.55-.47,7.51-3.93,9.01-1.73,.75-3.56,1.13-5.45,1.13"
      />
      <path
        class="cls-261"
        d="M393.74,84.7c2.25,0,4.43-.45,6.49-1.34,4.72-2.04,7.07-7.44,5.36-12.29l-10.64-30.05c-2.21-6.23-8.13-10.42-14.74-10.42h-56.86v2.62h56.86c5.5,0,10.43,3.48,12.27,8.67l10.64,30.05c1.26,3.56-.47,7.52-3.93,9.01-1.73,.75-3.57,1.13-5.45,1.13"
      />
      <path
        class="cls-235"
        d="M393.74,84.7c2.25,0,4.43-.45,6.49-1.34,4.72-2.04,7.07-7.44,5.35-12.28l-10.64-30.05c-2.2-6.23-8.12-10.41-14.73-10.41h-56.86v2.61h56.86c5.5,0,10.44,3.49,12.27,8.68l10.64,30.05c1.26,3.56-.47,7.52-3.93,9.02-1.73,.75-3.57,1.13-5.45,1.13"
      />
      <path
        class="cls-299"
        d="M393.74,84.69c2.24,0,4.43-.45,6.49-1.34,4.71-2.04,7.06-7.43,5.35-12.28l-10.64-30.05c-2.2-6.23-8.12-10.41-14.73-10.41h-56.86v2.59h56.86c5.51,0,10.44,3.49,12.28,8.68l10.64,30.05c1.26,3.56-.47,7.53-3.94,9.03-1.73,.75-3.57,1.13-5.45,1.13"
      />
      <path
        class="cls-244"
        d="M393.74,84.68c2.24,0,4.42-.45,6.48-1.34,4.71-2.04,7.06-7.43,5.35-12.27l-10.64-30.05c-2.2-6.22-8.12-10.4-14.72-10.4h-56.86v2.58h56.86c5.51,0,10.45,3.49,12.29,8.68l10.64,30.05c1.26,3.56-.47,7.53-3.94,9.04-1.73,.75-3.57,1.13-5.46,1.13"
      />
      <path
        class="cls-237"
        d="M393.74,84.68c2.24,0,4.42-.45,6.48-1.34,4.71-2.04,7.06-7.42,5.34-12.26l-10.64-30.05c-2.2-6.22-8.12-10.4-14.71-10.4h-56.86v2.57h56.86c5.51,0,10.45,3.49,12.29,8.69l10.64,30.05c1.26,3.57-.47,7.54-3.94,9.04-1.73,.75-3.57,1.13-5.46,1.13"
      />
      <path
        class="cls-252"
        d="M393.74,84.67c2.24,0,4.42-.45,6.48-1.34,4.71-2.04,7.05-7.42,5.34-12.25l-10.64-30.05c-2.2-6.22-8.11-10.4-14.71-10.4h-56.86v2.56h56.86c5.52,0,10.46,3.49,12.3,8.69l10.64,30.05c1.26,3.57-.47,7.55-3.95,9.05-1.74,.75-3.57,1.13-5.46,1.13"
      />
      <path
        class="cls-281"
        d="M393.74,84.66c2.24,0,4.42-.45,6.48-1.34,4.7-2.04,7.05-7.41,5.34-12.25l-10.64-30.05c-2.2-6.22-8.11-10.39-14.7-10.39h-56.86v2.55h56.86c5.52,0,10.46,3.49,12.3,8.7l10.64,30.05c1.27,3.57-.47,7.55-3.95,9.06-1.74,.75-3.57,1.13-5.46,1.13"
      />
      <path
        class="cls-229"
        d="M393.74,84.66c2.24,0,4.42-.45,6.47-1.34,4.7-2.03,7.04-7.41,5.33-12.24l-10.64-30.05c-2.2-6.21-8.11-10.39-14.7-10.39h-56.86v2.53h56.86c5.52,0,10.47,3.5,12.31,8.7l10.64,30.05c1.27,3.58-.47,7.56-3.95,9.07-1.74,.75-3.58,1.13-5.47,1.13"
      />
      <path
        class="cls-270"
        d="M393.74,84.65c2.24,0,4.42-.45,6.47-1.34,4.7-2.03,7.04-7.4,5.33-12.23l-10.64-30.05c-2.2-6.21-8.1-10.38-14.69-10.38h-56.86v2.52h56.86c5.52,0,10.47,3.5,12.31,8.7l10.64,30.05c1.27,3.58-.47,7.57-3.96,9.07-1.74,.75-3.58,1.13-5.47,1.13"
      />
      <path
        class="cls-478"
        d="M393.74,84.65c2.24,0,4.42-.45,6.47-1.34,4.69-2.03,7.03-7.4,5.33-12.22l-10.64-30.05c-2.2-6.21-8.1-10.38-14.69-10.38h-56.86v2.51h56.86c5.53,0,10.48,3.5,12.32,8.71l10.64,30.05c1.27,3.58-.47,7.57-3.96,9.08-1.74,.75-3.58,1.13-5.47,1.13"
      />
      <path
        class="cls-168"
        d="M393.74,84.64c2.24,0,4.41-.45,6.47-1.34,4.69-2.03,7.03-7.4,5.32-12.22l-10.64-30.05c-2.2-6.21-8.1-10.38-14.68-10.38h-56.86v2.5h56.86c5.53,0,10.48,3.5,12.33,8.71l10.64,30.05c1.27,3.59-.47,7.58-3.96,9.09-1.74,.75-3.58,1.13-5.47,1.13"
      />
      <path
        class="cls-130"
        d="M393.74,84.63c2.24,0,4.41-.45,6.46-1.34,4.69-2.03,7.03-7.39,5.32-12.21l-10.64-30.05c-2.2-6.2-8.09-10.37-14.67-10.37h-56.86v2.49h56.86c5.53,0,10.49,3.5,12.33,8.72l10.64,30.05c1.27,3.59-.47,7.58-3.97,9.1-1.74,.75-3.58,1.13-5.48,1.13"
      />
      <path
        class="cls-121"
        d="M393.74,84.63c2.24,0,4.41-.45,6.46-1.34,4.69-2.03,7.02-7.39,5.32-12.2l-10.64-30.05c-2.2-6.2-8.09-10.37-14.67-10.37h-56.86v2.47h56.86c5.53,0,10.49,3.5,12.34,8.72l10.64,30.05c1.27,3.59-.47,7.59-3.97,9.1-1.74,.75-3.58,1.14-5.48,1.14"
      />
      <path
        class="cls-160"
        d="M393.74,84.62c2.24,0,4.41-.45,6.46-1.34,4.68-2.03,7.02-7.38,5.31-12.19l-10.64-30.05c-2.19-6.2-8.09-10.36-14.66-10.36h-56.86v2.46h56.86c5.54,0,10.5,3.51,12.34,8.72l10.64,30.05c1.27,3.59-.47,7.6-3.97,9.11-1.74,.75-3.59,1.14-5.48,1.14"
      />
      <path
        class="cls-116"
        d="M393.74,84.62c2.23,0,4.41-.45,6.46-1.34,4.68-2.03,7.01-7.38,5.31-12.18l-10.64-30.05c-2.19-6.2-8.08-10.36-14.66-10.36h-56.86v2.45h56.86c5.54,0,10.5,3.51,12.35,8.73l10.64,30.05c1.27,3.6-.47,7.6-3.98,9.12-1.74,.75-3.59,1.14-5.48,1.14"
      />
      <path
        class="cls-529"
        d="M393.74,84.61c2.23,0,4.41-.45,6.45-1.34,4.68-2.02,7.01-7.37,5.31-12.18l-10.64-30.05c-2.19-6.19-8.08-10.36-14.65-10.36h-56.86v2.44h56.86c5.54,0,10.51,3.51,12.35,8.73l10.64,30.05c1.27,3.6-.47,7.61-3.98,9.13-1.74,.75-3.59,1.14-5.49,1.14"
      />
      <path
        class="cls-511"
        d="M393.74,84.6c2.23,0,4.4-.45,6.45-1.34,4.67-2.02,7-7.37,5.31-12.17l-10.64-30.05c-2.19-6.19-8.08-10.35-14.65-10.35h-56.86v2.43h56.86c5.54,0,10.51,3.51,12.36,8.74l10.64,30.05c1.28,3.6-.47,7.62-3.98,9.13-1.74,.75-3.59,1.14-5.49,1.14"
      />
      <path
        class="cls-95"
        d="M393.74,84.6c2.23,0,4.4-.45,6.45-1.34,4.67-2.02,7-7.36,5.3-12.16l-10.64-30.05c-2.19-6.19-8.07-10.35-14.64-10.35h-56.86v2.41h56.86c5.55,0,10.51,3.51,12.36,8.74l10.64,30.05c1.28,3.61-.47,7.62-3.99,9.14-1.74,.75-3.59,1.14-5.49,1.14"
      />
      <path
        class="cls-107"
        d="M393.74,84.59c2.23,0,4.4-.45,6.45-1.34,4.67-2.02,7-7.36,5.3-12.15l-10.64-30.05c-2.19-6.19-8.07-10.34-14.63-10.34h-56.86v2.4h56.86c5.55,0,10.52,3.51,12.37,8.74l10.64,30.05c1.28,3.61-.47,7.63-3.99,9.15-1.75,.76-3.59,1.14-5.49,1.14"
      />
      <path
        class="cls-488"
        d="M393.74,84.59c2.23,0,4.4-.45,6.44-1.33,4.67-2.02,6.99-7.35,5.3-12.15l-10.64-30.05c-2.19-6.18-8.07-10.34-14.63-10.34h-56.86v2.39h56.86c5.55,0,10.52,3.52,12.38,8.75l10.64,30.05c1.28,3.61-.47,7.63-3.99,9.16-1.75,.76-3.59,1.14-5.5,1.14"
      />
      <path
        class="cls-484"
        d="M393.74,84.58c2.23,0,4.4-.45,6.44-1.33,4.66-2.02,6.99-7.35,5.29-12.14l-10.64-30.05c-2.19-6.18-8.07-10.34-14.62-10.34h-56.86v2.38h56.86c5.55,0,10.53,3.52,12.38,8.75l10.64,30.05c1.28,3.62-.48,7.64-3.99,9.16-1.75,.76-3.6,1.14-5.5,1.14"
      />
      <path
        class="cls-459"
        d="M393.74,84.57c2.23,0,4.4-.45,6.44-1.33,4.66-2.02,6.98-7.35,5.29-12.13l-10.64-30.05c-2.19-6.18-8.06-10.33-14.62-10.33h-56.86v2.37h56.86c5.56,0,10.53,3.52,12.39,8.76l10.64,30.05c1.28,3.62-.48,7.65-4,9.17-1.75,.76-3.6,1.14-5.5,1.14"
      />
      <path
        class="cls-119"
        d="M393.74,84.57c2.23,0,4.39-.45,6.44-1.33,4.66-2.02,6.98-7.34,5.29-12.12l-10.64-30.05c-2.19-6.18-8.06-10.33-14.61-10.33h-56.86v2.35h56.86c5.56,0,10.54,3.52,12.39,8.76l10.64,30.05c1.28,3.62-.48,7.65-4,9.18-1.75,.76-3.6,1.14-5.5,1.14"
      />
      <path
        class="cls-177"
        d="M393.74,84.56c2.23,0,4.39-.45,6.44-1.33,4.65-2.01,6.97-7.34,5.28-12.12l-10.64-30.05c-2.19-6.18-8.06-10.32-14.61-10.32h-56.86v2.34h56.86c5.56,0,10.54,3.52,12.4,8.76l10.64,30.05c1.28,3.62-.48,7.66-4,9.19-1.75,.76-3.6,1.14-5.51,1.14"
      />
      <path
        class="cls-188"
        d="M393.74,84.56c2.23,0,4.39-.45,6.43-1.33,4.65-2.01,6.97-7.33,5.28-12.11l-10.64-30.05c-2.19-6.17-8.05-10.32-14.6-10.32h-56.86v2.33h56.86c5.56,0,10.55,3.52,12.4,8.77l10.64,30.05c1.28,3.63-.48,7.67-4.01,9.19-1.75,.76-3.6,1.14-5.51,1.14"
      />
      <path
        class="cls-176"
        d="M393.74,84.55c2.23,0,4.39-.45,6.43-1.33,4.65-2.01,6.97-7.33,5.28-12.1l-10.64-30.05c-2.18-6.17-8.05-10.32-14.59-10.32h-56.86v2.32h56.86c5.57,0,10.55,3.53,12.41,8.77l10.64,30.05c1.29,3.63-.48,7.67-4.01,9.2-1.75,.76-3.6,1.14-5.51,1.14"
      />
      <path
        class="cls-206"
        d="M393.74,84.54c2.22,0,4.39-.45,6.43-1.33,4.65-2.01,6.96-7.32,5.27-12.09l-10.64-30.05c-2.18-6.17-8.05-10.31-14.59-10.31h-56.86v2.31h56.86c5.57,0,10.56,3.53,12.42,8.78l10.64,30.05c1.29,3.63-.48,7.68-4.01,9.21-1.75,.76-3.61,1.14-5.51,1.14"
      />
      <path
        class="cls-212"
        d="M393.74,84.54c2.22,0,4.39-.45,6.43-1.33,4.64-2.01,6.96-7.32,5.27-12.09l-10.64-30.05c-2.18-6.17-8.04-10.31-14.58-10.31h-56.86v2.29h56.86c5.57,0,10.56,3.53,12.42,8.78l10.64,30.05c1.29,3.64-.48,7.68-4.02,9.22-1.75,.76-3.61,1.14-5.51,1.14"
      />
      <path
        class="cls-163"
        d="M393.74,84.53c2.22,0,4.38-.45,6.42-1.33,4.64-2.01,6.95-7.31,5.27-12.08l-10.64-30.05c-2.18-6.16-8.04-10.3-14.58-10.3h-56.86v2.28h56.86c5.57,0,10.57,3.53,12.43,8.78l10.64,30.05c1.29,3.64-.48,7.69-4.02,9.22-1.75,.76-3.61,1.14-5.52,1.14"
      />
      <path
        class="cls-145"
        d="M393.74,84.53c2.22,0,4.38-.45,6.42-1.33,4.64-2.01,6.95-7.31,5.26-12.07l-10.64-30.05c-2.18-6.16-8.04-10.3-14.57-10.3h-56.86v2.27h56.86c5.58,0,10.57,3.53,12.43,8.79l10.64,30.05c1.29,3.64-.48,7.7-4.02,9.23-1.75,.76-3.61,1.14-5.52,1.14"
      />
      <path
        class="cls-514"
        d="M393.74,84.52c2.22,0,4.38-.45,6.42-1.33,4.63-2.01,6.94-7.3,5.26-12.06l-10.64-30.05c-2.18-6.16-8.03-10.3-14.57-10.3h-56.86v2.26h56.86c5.58,0,10.58,3.53,12.44,8.79l10.64,30.05c1.29,3.65-.48,7.7-4.03,9.24-1.75,.76-3.61,1.14-5.52,1.14"
      />
      <path
        class="cls-522"
        d="M393.74,84.51c2.22,0,4.38-.45,6.42-1.33,4.63-2,6.94-7.3,5.26-12.06l-10.64-30.05c-2.18-6.16-8.03-10.29-14.56-10.29h-56.86v2.25h56.86c5.58,0,10.58,3.53,12.44,8.8l10.64,30.05c1.29,3.65-.48,7.71-4.03,9.25-1.75,.76-3.61,1.14-5.52,1.14"
      />
      <path
        class="cls-524"
        d="M393.74,84.51c2.22,0,4.38-.45,6.41-1.33,4.63-2,6.93-7.3,5.25-12.05l-10.64-30.05c-2.18-6.15-8.03-10.29-14.56-10.29h-56.86v2.23h56.86c5.58,0,10.59,3.54,12.45,8.8l10.64,30.05c1.29,3.65-.48,7.72-4.03,9.25-1.76,.76-3.62,1.14-5.53,1.14"
      />
      <path
        class="cls-219"
        d="M393.74,84.5c2.22,0,4.38-.45,6.41-1.33,4.62-2,6.93-7.29,5.25-12.04l-10.64-30.05c-2.18-6.15-8.02-10.28-14.55-10.28h-56.86v2.22h56.86c5.59,0,10.59,3.54,12.46,8.8l10.64,30.05c1.29,3.65-.48,7.72-4.04,9.26-1.76,.76-3.62,1.15-5.53,1.15"
      />
      <path
        class="cls-131"
        d="M393.74,84.5c2.22,0,4.37-.45,6.41-1.33,4.62-2,6.93-7.29,5.25-12.03l-10.64-30.05c-2.18-6.15-8.02-10.28-14.54-10.28h-56.86v2.21h56.86c5.59,0,10.6,3.54,12.46,8.81l10.64,30.05c1.29,3.66-.48,7.73-4.04,9.27-1.76,.76-3.62,1.15-5.53,1.15"
      />
      <path
        class="cls-705"
        d="M393.74,84.49c2.22,0,4.37-.45,6.41-1.33,4.62-2,6.92-7.28,5.24-12.03l-10.64-30.05c-2.18-6.15-8.02-10.28-14.54-10.28h-56.86v2.2h56.86c5.59,0,10.6,3.54,12.47,8.81l10.64,30.05c1.3,3.66-.48,7.73-4.04,9.28-1.76,.76-3.62,1.15-5.53,1.15"
      />
      <path
        class="cls-621"
        d="M393.74,84.48c2.22,0,4.37-.45,6.4-1.33,4.62-2,6.92-7.28,5.24-12.02l-10.64-30.05c-2.17-6.14-8.02-10.27-14.53-10.27h-56.86v2.18h56.86c5.59,0,10.61,3.54,12.47,8.82l10.64,30.05c1.3,3.66-.48,7.74-4.05,9.28-1.76,.76-3.62,1.15-5.54,1.15"
      />
      <path
        class="cls-702"
        d="M393.74,84.48c2.22,0,4.37-.45,6.4-1.33,4.61-2,6.91-7.27,5.24-12.01l-10.64-30.05c-2.17-6.14-8.01-10.27-14.53-10.27h-56.86v2.17h56.86c5.6,0,10.61,3.54,12.48,8.82l10.64,30.05c1.3,3.67-.48,7.75-4.05,9.29-1.76,.76-3.62,1.15-5.54,1.15"
      />
      <path
        class="cls-466"
        d="M393.74,84.47c2.21,0,4.37-.45,6.4-1.33,4.61-2,6.91-7.27,5.23-12l-10.64-30.05c-2.17-6.14-8.01-10.26-14.52-10.26h-56.86v2.16h56.86c5.6,0,10.62,3.55,12.48,8.82l10.64,30.05c1.3,3.67-.48,7.75-4.05,9.3-1.76,.76-3.62,1.15-5.54,1.15"
      />
      <path
        class="cls-114"
        d="M393.74,84.47c2.21,0,4.37-.45,6.4-1.32,4.61-1.99,6.9-7.26,5.23-12l-10.64-30.05c-2.17-6.14-8.01-10.26-14.52-10.26h-56.86v2.15h56.86c5.6,0,10.62,3.55,12.49,8.83l10.64,30.05c1.3,3.67-.48,7.76-4.06,9.31-1.76,.76-3.63,1.15-5.54,1.15"
      />
      <path
        class="cls-66"
        d="M393.74,84.46c2.21,0,4.36-.45,6.39-1.32,4.6-1.99,6.9-7.26,5.23-11.99l-10.64-30.05c-2.17-6.13-8-10.26-14.51-10.26h-56.86v2.14h56.86c5.6,0,10.63,3.55,12.5,8.83l10.64,30.05c1.3,3.67-.48,7.77-4.06,9.31-1.76,.76-3.63,1.15-5.55,1.15"
      />
      <path
        class="cls-704"
        d="M393.74,84.45c2.21,0,4.36-.45,6.39-1.32,4.6-1.99,6.9-7.25,5.22-11.98l-10.64-30.05c-2.17-6.13-8-10.25-14.5-10.25h-56.86v2.12h56.86c5.61,0,10.63,3.55,12.5,8.84l10.64,30.05c1.3,3.68-.48,7.77-4.06,9.32-1.76,.76-3.63,1.15-5.55,1.15"
      />
      <path
        class="cls-714"
        d="M393.74,84.45c2.21,0,4.36-.45,6.39-1.32,4.6-1.99,6.89-7.25,5.22-11.97l-10.64-30.05c-2.17-6.13-8-10.25-14.5-10.25h-56.86v2.11h56.86c5.61,0,10.64,3.55,12.51,8.84l10.64,30.05c1.3,3.68-.48,7.78-4.07,9.33-1.76,.76-3.63,1.15-5.55,1.15"
      />
      <path
        class="cls-670"
        d="M393.74,84.44c2.21,0,4.36-.45,6.39-1.32,4.6-1.99,6.89-7.25,5.22-11.97l-10.64-30.05c-2.17-6.13-7.99-10.24-14.49-10.24h-56.86v2.1h56.86c5.61,0,10.64,3.55,12.51,8.84l10.64,30.05c1.3,3.68-.48,7.79-4.07,9.34-1.76,.76-3.63,1.15-5.55,1.15"
      />
      <path
        class="cls-666"
        d="M393.74,84.44c2.21,0,4.36-.45,6.39-1.32,4.59-1.99,6.88-7.24,5.21-11.96l-10.64-30.05c-2.17-6.12-7.99-10.24-14.49-10.24h-56.86v2.09h56.86c5.61,0,10.64,3.56,12.52,8.85l10.64,30.05c1.31,3.69-.48,7.79-4.07,9.34-1.76,.76-3.63,1.15-5.56,1.15"
      />
      <path
        class="cls-693"
        d="M393.74,84.43c2.21,0,4.36-.44,6.38-1.32,4.59-1.99,6.88-7.24,5.21-11.95l-10.64-30.05c-2.17-6.12-7.99-10.24-14.48-10.24h-56.86v2.08h56.86c5.62,0,10.65,3.56,12.52,8.85l10.64,30.05c1.31,3.69-.48,7.8-4.08,9.35-1.77,.76-3.64,1.15-5.56,1.15"
      />
      <path
        class="cls-660"
        d="M393.74,84.42c2.21,0,4.35-.44,6.38-1.32,4.59-1.99,6.87-7.23,5.21-11.94l-10.64-30.05c-2.17-6.12-7.98-10.23-14.48-10.23h-56.86v2.06h56.86c5.62,0,10.65,3.56,12.53,8.86l10.64,30.05c1.31,3.69-.49,7.8-4.08,9.36-1.77,.76-3.64,1.15-5.56,1.15"
      />
      <path
        class="cls-656"
        d="M393.74,84.42c2.21,0,4.35-.44,6.38-1.32,4.58-1.98,6.87-7.23,5.2-11.94l-10.64-30.05c-2.17-6.12-7.98-10.23-14.47-10.23h-56.86v2.05h56.86c5.62,0,10.66,3.56,12.53,8.86l10.64,30.05c1.31,3.7-.49,7.81-4.08,9.37-1.77,.76-3.64,1.15-5.56,1.15"
      />
      <path
        class="cls-655"
        d="M393.74,84.41c2.21,0,4.35-.44,6.38-1.32,4.58-1.98,6.87-7.22,5.2-11.93l-10.64-30.05c-2.16-6.12-7.98-10.22-14.46-10.22h-56.86v2.04h56.86c5.62,0,10.66,3.56,12.54,8.86l10.64,30.05c1.31,3.7-.49,7.82-4.09,9.38-1.77,.77-3.64,1.15-5.56,1.15"
      />
      <path
        class="cls-80"
        d="M393.74,84.41c2.21,0,4.35-.44,6.37-1.32,4.58-1.98,6.86-7.22,5.2-11.92l-10.64-30.05c-2.16-6.11-7.97-10.22-14.46-10.22h-56.86v2.03h56.86c5.63,0,10.67,3.56,12.55,8.87l10.64,30.05c1.31,3.7-.49,7.82-4.09,9.38-1.77,.77-3.64,1.15-5.57,1.15"
      />
      <path
        class="cls-82"
        d="M393.74,84.4c2.2,0,4.35-.44,6.37-1.32,4.58-1.98,6.86-7.21,5.19-11.91l-10.64-30.05c-2.16-6.11-7.97-10.22-14.45-10.22h-56.86v2.02h56.86c5.63,0,10.67,3.57,12.55,8.87l10.64,30.05c1.31,3.7-.49,7.83-4.09,9.39-1.77,.77-3.64,1.15-5.57,1.15"
      />
      <path
        class="cls-680"
        d="M393.74,84.39c2.2,0,4.35-.44,6.37-1.32,4.57-1.98,6.85-7.21,5.19-11.91l-10.64-30.05c-2.16-6.11-7.97-10.21-14.45-10.21h-56.86v2h56.86c5.63,0,10.68,3.57,12.56,8.88l10.64,30.05c1.31,3.71-.49,7.84-4.1,9.4-1.77,.77-3.64,1.15-5.57,1.15"
      />
      <path
        class="cls-477"
        d="M393.74,84.39c2.2,0,4.35-.44,6.37-1.32,4.57-1.98,6.85-7.2,5.19-11.9l-10.64-30.05c-2.16-6.11-7.96-10.21-14.44-10.21h-56.86v1.99h56.86c5.63,0,10.68,3.57,12.56,8.88l10.64,30.05c1.31,3.71-.49,7.84-4.1,9.41-1.77,.77-3.65,1.15-5.57,1.15"
      />
      <path
        class="cls-470"
        d="M393.74,84.38c2.2,0,4.34-.44,6.36-1.32,4.57-1.98,6.84-7.2,5.18-11.89l-10.64-30.05c-2.16-6.1-7.96-10.2-14.44-10.2h-56.86v1.98h56.86c5.64,0,10.69,3.57,12.57,8.88l10.64,30.05c1.31,3.71-.49,7.85-4.1,9.41-1.77,.77-3.65,1.16-5.58,1.16"
      />
      <path
        class="cls-469"
        d="M393.74,84.38c2.2,0,4.34-.44,6.36-1.32,4.56-1.98,6.84-7.2,5.18-11.88l-10.64-30.05c-2.16-6.1-7.96-10.2-14.43-10.2h-56.86v1.97h56.86c5.64,0,10.69,3.57,12.57,8.89l10.64,30.05c1.32,3.72-.49,7.85-4.11,9.42-1.77,.77-3.65,1.16-5.58,1.16"
      />
      <path
        class="cls-516"
        d="M393.74,84.37c2.2,0,4.34-.44,6.36-1.32,4.56-1.97,6.84-7.19,5.18-11.88l-10.64-30.05c-2.16-6.1-7.96-10.2-14.42-10.2h-56.86v1.96h56.86c5.64,0,10.7,3.57,12.58,8.89l10.64,30.05c1.32,3.72-.49,7.86-4.11,9.43-1.77,.77-3.65,1.16-5.58,1.16"
      />
      <path
        class="cls-112"
        d="M393.74,84.36c2.2,0,4.34-.44,6.36-1.32,4.56-1.97,6.83-7.19,5.17-11.87l-10.64-30.05c-2.16-6.1-7.95-10.19-14.42-10.19h-56.86v1.94h56.86c5.64,0,10.7,3.58,12.59,8.9l10.64,30.05c1.32,3.72-.49,7.87-4.11,9.44-1.77,.77-3.65,1.16-5.58,1.16"
      />
      <path
        class="cls-69"
        d="M393.74,84.36c2.2,0,4.34-.44,6.35-1.32,4.56-1.97,6.83-7.18,5.17-11.86l-10.64-30.05c-2.16-6.09-7.95-10.19-14.41-10.19h-56.86v1.93h56.86c5.65,0,10.71,3.58,12.59,8.9l10.64,30.05c1.32,3.73-.49,7.87-4.12,9.44-1.77,.77-3.65,1.16-5.59,1.16"
      />
      <path
        class="cls-23"
        d="M393.74,84.35c2.2,0,4.34-.44,6.35-1.32,4.55-1.97,6.82-7.18,5.17-11.85l-10.64-30.05c-2.16-6.09-7.95-10.18-14.41-10.18h-56.86v1.92h56.86c5.65,0,10.71,3.58,12.6,8.9l10.64,30.05c1.32,3.73-.49,7.88-4.12,9.45-1.78,.77-3.66,1.16-5.59,1.16"
      />
      <path
        class="cls-15"
        d="M393.74,84.35c2.2,0,4.33-.44,6.35-1.32,4.55-1.97,6.82-7.17,5.16-11.85l-10.64-30.05c-2.16-6.09-7.94-10.18-14.4-10.18h-56.86v1.91h56.86c5.65,0,10.72,3.58,12.6,8.91l10.64,30.05c1.32,3.73-.49,7.89-4.12,9.46-1.78,.77-3.66,1.16-5.59,1.16"
      />
      <path
        class="cls-83"
        d="M393.74,84.34c2.2,0,4.33-.44,6.35-1.31,4.55-1.97,6.81-7.17,5.16-11.84l-10.64-30.05c-2.15-6.09-7.94-10.18-14.4-10.18h-56.86v1.9h56.86c5.65,0,10.72,3.58,12.61,8.91l10.64,30.05c1.32,3.73-.49,7.89-4.13,9.47-1.78,.77-3.66,1.16-5.59,1.16"
      />
      <path
        class="cls-18"
        d="M393.74,84.33c2.2,0,4.33-.44,6.34-1.31,4.54-1.97,6.81-7.16,5.16-11.83l-10.64-30.05c-2.15-6.08-7.94-10.17-14.39-10.17h-56.86v1.88h56.86c5.66,0,10.73,3.58,12.61,8.92l10.64,30.05c1.32,3.74-.49,7.9-4.13,9.47-1.78,.77-3.66,1.16-5.6,1.16"
      />
      <path
        class="cls-193"
        d="M393.74,84.33c2.2,0,4.33-.44,6.34-1.31,4.54-1.97,6.81-7.16,5.15-11.82l-10.64-30.05c-2.15-6.08-7.93-10.17-14.39-10.17h-56.86v1.87h56.86c5.66,0,10.73,3.58,12.62,8.92l10.64,30.05c1.32,3.74-.49,7.9-4.13,9.48-1.78,.77-3.66,1.16-5.6,1.16"
      />
      <path
        class="cls-76"
        d="M393.74,84.32c2.19,0,4.33-.44,6.34-1.31,4.54-1.96,6.8-7.15,5.15-11.82l-10.64-30.05c-2.15-6.08-7.93-10.16-14.38-10.16h-56.86v1.86h56.86c5.66,0,10.74,3.59,12.63,8.92l10.64,30.05c1.32,3.74-.49,7.91-4.14,9.49-1.78,.77-3.66,1.16-5.6,1.16"
      />
      <path
        class="cls-541"
        d="M393.74,84.32c2.19,0,4.33-.44,6.34-1.31,4.54-1.96,6.8-7.15,5.15-11.81l-10.64-30.05c-2.15-6.08-7.93-10.16-14.37-10.16h-56.86v1.85h56.86c5.66,0,10.74,3.59,12.63,8.93l10.64,30.05c1.33,3.75-.49,7.92-4.14,9.5-1.78,.77-3.67,1.16-5.6,1.16"
      />
      <path
        class="cls-542"
        d="M393.74,84.31c2.19,0,4.32-.44,6.34-1.31,4.53-1.96,6.79-7.15,5.14-11.8l-10.64-30.05c-2.15-6.07-7.92-10.16-14.37-10.16h-56.86v1.84h56.86c5.67,0,10.75,3.59,12.64,8.93l10.64,30.05c1.33,3.75-.49,7.92-4.14,9.5-1.78,.77-3.67,1.16-5.61,1.16"
      />
      <path
        class="cls-636"
        d="M393.74,84.3c2.19,0,4.32-.44,6.33-1.31,4.53-1.96,6.79-7.14,5.14-11.79l-10.64-30.05c-2.15-6.07-7.92-10.15-14.36-10.15h-56.86v1.82h56.86c5.67,0,10.75,3.59,12.64,8.94l10.64,30.05c1.33,3.75-.49,7.93-4.15,9.51-1.78,.77-3.67,1.16-5.61,1.16"
      />
      <path
        class="cls-625"
        d="M393.74,84.3c2.19,0,4.32-.44,6.33-1.31,4.53-1.96,6.78-7.14,5.14-11.79l-10.64-30.05c-2.15-6.07-7.92-10.15-14.36-10.15h-56.86v1.81h56.86c5.67,0,10.76,3.59,12.65,8.94l10.64,30.05c1.33,3.75-.49,7.94-4.15,9.52-1.78,.77-3.67,1.16-5.61,1.16"
      />
      <path
        class="cls-644"
        d="M393.74,84.29c2.19,0,4.32-.44,6.33-1.31,4.52-1.96,6.78-7.13,5.13-11.78l-10.64-30.05c-2.15-6.07-7.91-10.14-14.35-10.14h-56.86v1.8h56.86c5.68,0,10.76,3.59,12.65,8.94l10.64,30.05c1.33,3.76-.49,7.94-4.15,9.53-1.78,.77-3.67,1.16-5.61,1.16"
      />
      <path
        class="cls-633"
        d="M393.74,84.29c2.19,0,4.32-.44,6.33-1.31,4.52-1.96,6.77-7.13,5.13-11.77l-10.64-30.05c-2.15-6.06-7.91-10.14-14.35-10.14h-56.86v1.79h56.86c5.68,0,10.77,3.6,12.66,8.95l10.64,30.05c1.33,3.76-.49,7.95-4.16,9.53-1.78,.77-3.67,1.16-5.61,1.16"
      />
      <path
        class="cls-676"
        d="M393.74,84.28c2.19,0,4.32-.44,6.32-1.31,4.52-1.96,6.77-7.12,5.13-11.76l-10.64-30.05c-2.15-6.06-7.91-10.14-14.34-10.14h-56.86v1.78h56.86c5.68,0,10.77,3.6,12.67,8.95l10.64,30.05c1.33,3.76-.49,7.95-4.16,9.54-1.78,.77-3.67,1.16-5.62,1.16"
      />
      <path
        class="cls-650"
        d="M393.74,84.27c2.19,0,4.31-.44,6.32-1.31,4.52-1.95,6.77-7.12,5.12-11.76l-10.64-30.05c-2.15-6.06-7.91-10.13-14.33-10.13h-56.86v1.76h56.86c5.68,0,10.77,3.6,12.67,8.96l10.64,30.05c1.33,3.77-.5,7.96-4.16,9.55-1.79,.77-3.68,1.16-5.62,1.16"
      />
      <path
        class="cls-544"
        d="M393.74,84.27c2.19,0,4.31-.44,6.32-1.31,4.51-1.95,6.76-7.11,5.12-11.75l-10.64-30.05c-2.14-6.06-7.9-10.13-14.33-10.13h-56.86v1.75h56.86c5.69,0,10.78,3.6,12.68,8.96l10.64,30.05c1.33,3.77-.5,7.97-4.17,9.56-1.79,.77-3.68,1.16-5.62,1.16"
      />
      <path
        class="cls-549"
        d="M393.74,84.26c2.19,0,4.31-.44,6.32-1.31,4.51-1.95,6.76-7.11,5.12-11.74l-10.64-30.05c-2.14-6.06-7.9-10.12-14.32-10.12h-56.86v1.74h56.86c5.69,0,10.78,3.6,12.68,8.96l10.64,30.05c1.34,3.77-.5,7.97-4.17,9.56-1.79,.77-3.68,1.17-5.62,1.17"
      />
      <path
        class="cls-594"
        d="M393.74,84.26c2.19,0,4.31-.44,6.31-1.31,4.51-1.95,6.75-7.1,5.11-11.73l-10.64-30.05c-2.14-6.05-7.9-10.12-14.32-10.12h-56.86v1.73h56.86c5.69,0,10.79,3.6,12.69,8.97l10.64,30.05c1.34,3.78-.5,7.98-4.17,9.57-1.79,.77-3.68,1.17-5.63,1.17"
      />
      <path
        class="cls-550"
        d="M393.74,84.25c2.18,0,4.31-.44,6.31-1.31,4.5-1.95,6.75-7.1,5.11-11.73l-10.64-30.05c-2.14-6.05-7.89-10.12-14.31-10.12h-56.86v1.72h56.86c5.69,0,10.79,3.61,12.69,8.97l10.64,30.05c1.34,3.78-.5,7.99-4.18,9.58-1.79,.77-3.68,1.17-5.63,1.17"
      />
      <path
        class="cls-604"
        d="M393.74,84.24c2.18,0,4.31-.44,6.31-1.31,4.5-1.95,6.74-7.09,5.11-11.72l-10.64-30.05c-2.14-6.05-7.89-10.11-14.31-10.11h-56.86v1.7h56.86c5.7,0,10.8,3.61,12.7,8.98l10.64,30.05c1.34,3.78-.5,7.99-4.18,9.59-1.79,.77-3.68,1.17-5.63,1.17"
      />
      <path
        class="cls-612"
        d="M393.74,84.24c2.18,0,4.3-.44,6.31-1.31,4.5-1.95,6.74-7.09,5.1-11.71l-10.64-30.05c-2.14-6.05-7.89-10.11-14.3-10.11h-56.86v1.69h56.86c5.7,0,10.8,3.61,12.7,8.98l10.64,30.05c1.34,3.78-.5,8-4.18,9.59-1.79,.77-3.69,1.17-5.63,1.17"
      />
      <path
        class="cls-558"
        d="M393.74,84.23c2.18,0,4.3-.44,6.3-1.31,4.49-1.95,6.74-7.09,5.1-11.7l-10.64-30.05c-2.14-6.04-7.88-10.1-14.29-10.1h-56.86v1.68h56.86c5.7,0,10.81,3.61,12.71,8.98l10.64,30.05c1.34,3.79-.5,8-4.19,9.6-1.79,.77-3.69,1.17-5.64,1.17"
      />
      <path
        class="cls-538"
        d="M393.74,84.23c2.18,0,4.3-.44,6.3-1.31,4.49-1.94,6.73-7.08,5.1-11.7l-10.64-30.05c-2.14-6.04-7.88-10.1-14.29-10.1h-56.86v1.67h56.86c5.7,0,10.81,3.61,12.72,8.99l10.64,30.05c1.34,3.79-.5,8.01-4.19,9.61-1.79,.78-3.69,1.17-5.64,1.17"
      />
      <path
        class="cls-498"
        d="M393.74,84.22c2.18,0,4.3-.44,6.3-1.3,4.49-1.94,6.73-7.08,5.1-11.69l-10.64-30.05c-2.14-6.04-7.88-10.1-14.28-10.1h-56.86v1.66h56.86c5.71,0,10.82,3.61,12.72,8.99l10.64,30.05c1.34,3.79-.5,8.02-4.19,9.62-1.79,.78-3.69,1.17-5.64,1.17"
      />
      <path
        class="cls-506"
        d="M393.74,84.21c2.18,0,4.3-.44,6.3-1.3,4.49-1.94,6.72-7.07,5.09-11.68l-10.64-30.05c-2.14-6.04-7.87-10.09-14.28-10.09h-56.86v1.64h56.86c5.71,0,10.82,3.62,12.73,9l10.64,30.05c1.34,3.8-.5,8.02-4.19,9.62-1.79,.78-3.69,1.17-5.64,1.17"
      />
      <path
        class="cls-690"
        d="M393.74,84.21c2.18,0,4.3-.44,6.29-1.3,4.48-1.94,6.72-7.07,5.09-11.67l-10.64-30.05c-2.14-6.03-7.87-10.09-14.27-10.09h-56.86v1.63h56.86c5.71,0,10.83,3.62,12.73,9l10.64,30.05c1.34,3.8-.5,8.03-4.2,9.63-1.79,.78-3.69,1.17-5.65,1.17"
      />
      <path
        class="cls-721"
        d="M393.74,84.2c2.18,0,4.29-.44,6.29-1.3,4.48-1.94,6.71-7.06,5.09-11.67l-10.64-30.05c-2.14-6.03-7.87-10.08-14.27-10.08h-56.86v1.62h56.86c5.71,0,10.83,3.62,12.74,9l10.64,30.05c1.35,3.8-.5,8.04-4.2,9.64-1.79,.78-3.69,1.17-5.65,1.17"
      />
      <path
        class="cls-698"
        d="M393.74,84.2c2.18,0,4.29-.44,6.29-1.3,4.48-1.94,6.71-7.06,5.08-11.66l-10.64-30.05c-2.13-6.03-7.86-10.08-14.26-10.08h-56.86v1.61h56.86c5.72,0,10.84,3.62,12.74,9.01l10.64,30.05c1.35,3.81-.5,8.04-4.2,9.65-1.8,.78-3.7,1.17-5.65,1.17"
      />
      <path
        class="cls-695"
        d="M393.74,84.19c2.18,0,4.29-.44,6.29-1.3,4.47-1.94,6.71-7.05,5.08-11.65l-10.64-30.05c-2.13-6.03-7.86-10.08-14.25-10.08h-56.86v1.6h56.86c5.72,0,10.84,3.62,12.75,9.01l10.64,30.05c1.35,3.81-.5,8.05-4.21,9.65-1.8,.78-3.7,1.17-5.65,1.17"
      />
      <path
        class="cls-681"
        d="M393.74,84.18c2.18,0,4.29-.44,6.29-1.3,4.47-1.94,6.7-7.05,5.08-11.64l-10.64-30.05c-2.13-6.02-7.86-10.07-14.25-10.07h-56.86v1.58h56.86c5.72,0,10.85,3.62,12.76,9.02l10.64,30.05c1.35,3.81-.5,8.05-4.21,9.66-1.8,.78-3.7,1.17-5.66,1.17"
      />
      <path
        class="cls-715"
        d="M393.74,84.18c2.17,0,4.29-.44,6.28-1.3,4.47-1.93,6.7-7.04,5.07-11.64l-10.64-30.05c-2.13-6.02-7.86-10.07-14.24-10.07h-56.86v1.57h56.86c5.72,0,10.85,3.62,12.76,9.02l10.64,30.05c1.35,3.81-.5,8.06-4.21,9.67-1.8,.78-3.7,1.17-5.66,1.17"
      />
      <path
        class="cls-710"
        d="M393.74,84.17c2.17,0,4.29-.44,6.28-1.3,4.47-1.93,6.69-7.04,5.07-11.63l-10.64-30.05c-2.13-6.02-7.85-10.06-14.24-10.06h-56.86v1.56h56.86c5.73,0,10.86,3.63,12.77,9.02l10.64,30.05c1.35,3.82-.5,8.07-4.22,9.68-1.8,.78-3.7,1.17-5.66,1.17"
      />
      <path
        class="cls-627"
        d="M393.74,84.17c2.17,0,4.28-.44,6.28-1.3,4.46-1.93,6.69-7.04,5.07-11.62l-10.64-30.05c-2.13-6.02-7.85-10.06-14.23-10.06h-56.86v1.55h56.86c5.73,0,10.86,3.63,12.77,9.03l10.64,30.05c1.35,3.82-.5,8.07-4.22,9.68-1.8,.78-3.7,1.17-5.66,1.17"
      />
      <path
        class="cls-673"
        d="M393.74,84.16c2.17,0,4.28-.44,6.28-1.3,4.46-1.93,6.68-7.03,5.06-11.61l-10.64-30.05c-2.13-6.01-7.85-10.06-14.23-10.06h-56.86v1.54h56.86c5.73,0,10.87,3.63,12.78,9.03l10.64,30.05c1.35,3.82-.5,8.08-4.22,9.69-1.8,.78-3.71,1.17-5.67,1.17"
      />
      <path
        class="cls-639"
        d="M393.74,84.15c2.17,0,4.28-.44,6.27-1.3,4.46-1.93,6.68-7.03,5.06-11.61l-10.64-30.05c-2.13-6.01-7.84-10.05-14.22-10.05h-56.86v1.52h56.86c5.73,0,10.87,3.63,12.78,9.04l10.64,30.05c1.35,3.83-.5,8.09-4.23,9.7-1.8,.78-3.71,1.17-5.67,1.17"
      />
      <path
        class="cls-492"
        d="M393.74,84.15c2.17,0,4.28-.44,6.27-1.3,4.45-1.93,6.68-7.02,5.06-11.6l-10.64-30.05c-2.13-6.01-7.84-10.05-14.22-10.05h-56.86v1.51h56.86c5.74,0,10.88,3.63,12.79,9.04l10.64,30.05c1.36,3.83-.5,8.09-4.23,9.71-1.8,.78-3.71,1.17-5.67,1.17"
      />
      <path
        class="cls-568"
        d="M393.74,84.14c2.17,0,4.28-.44,6.27-1.3,4.45-1.93,6.67-7.02,5.05-11.59l-10.64-30.05c-2.13-6.01-7.84-10.04-14.21-10.04h-56.86v1.5h56.86c5.74,0,10.88,3.63,12.8,9.04l10.64,30.05c1.36,3.83-.5,8.1-4.23,9.71-1.8,.78-3.71,1.18-5.67,1.18"
      />
      <path
        class="cls-571"
        d="M393.74,84.14c2.17,0,4.28-.44,6.27-1.3,4.45-1.93,6.67-7.01,5.05-11.58l-10.64-30.05c-2.13-6-7.83-10.04-14.2-10.04h-56.86v1.49h56.86c5.74,0,10.89,3.64,12.8,9.05l10.64,30.05c1.36,3.83-.5,8.11-4.24,9.72-1.8,.78-3.71,1.18-5.67,1.18"
      />
      <path
        class="cls-497"
        d="M393.74,84.13c2.17,0,4.28-.44,6.26-1.3,4.45-1.92,6.66-7.01,5.05-11.58l-10.64-30.05c-2.12-6-7.83-10.04-14.2-10.04h-56.86v1.48h56.86c5.74,0,10.89,3.64,12.81,9.05l10.64,30.05c1.36,3.84-.5,8.11-4.24,9.73-1.8,.78-3.71,1.18-5.68,1.18"
      />
      <path
        class="cls-447"
        d="M393.74,84.12c2.17,0,4.27-.44,6.26-1.3,4.44-1.92,6.66-7,5.04-11.57l-10.64-30.05c-2.12-6-7.83-10.03-14.19-10.03h-56.86v1.46h56.86c5.75,0,10.9,3.64,12.81,9.06l10.64,30.05c1.36,3.84-.5,8.12-4.24,9.74-1.8,.78-3.72,1.18-5.68,1.18"
      />
      <path
        class="cls-444"
        d="M393.74,84.12c2.17,0,4.27-.44,6.26-1.3,4.44-1.92,6.65-7,5.04-11.56l-10.64-30.05c-2.12-6-7.82-10.03-14.19-10.03h-56.86v1.45h56.86c5.75,0,10.9,3.64,12.82,9.06l10.64,30.05c1.36,3.84-.51,8.12-4.25,9.74-1.81,.78-3.72,1.18-5.68,1.18"
      />
      <path
        class="cls-440"
        d="M393.74,84.11c2.17,0,4.27-.44,6.26-1.3,4.44-1.92,6.65-6.99,5.04-11.55l-10.64-30.05c-2.12-6-7.82-10.02-14.18-10.02h-56.86v1.44h56.86c5.75,0,10.91,3.64,12.82,9.06l10.64,30.05c1.36,3.85-.51,8.13-4.25,9.75-1.81,.78-3.72,1.18-5.68,1.18"
      />
      <path
        class="cls-427"
        d="M393.74,84.11c2.16,0,4.27-.44,6.25-1.3,4.43-1.92,6.64-6.99,5.03-11.55l-10.64-30.05c-2.12-5.99-7.82-10.02-14.18-10.02h-56.86v1.43h56.86c5.75,0,10.91,3.64,12.83,9.07l10.64,30.05c1.36,3.85-.51,8.14-4.25,9.76-1.81,.78-3.72,1.18-5.69,1.18"
      />
      <path
        class="cls-423"
        d="M393.74,84.1c2.16,0,4.27-.44,6.25-1.29,4.43-1.92,6.64-6.99,5.03-11.54l-10.64-30.05c-2.12-5.99-7.81-10.02-14.17-10.02h-56.86v1.42h56.86c5.76,0,10.91,3.65,12.84,9.07l10.64,30.05c1.36,3.85-.51,8.14-4.26,9.77-1.81,.78-3.72,1.18-5.69,1.18"
      />
      <path
        class="cls-433"
        d="M393.74,84.09c2.16,0,4.27-.44,6.25-1.29,4.43-1.92,6.64-6.98,5.03-11.53l-10.64-30.05c-2.12-5.99-7.81-10.01-14.16-10.01h-56.86v1.4h56.86c5.76,0,10.92,3.65,12.84,9.08l10.64,30.05c1.36,3.86-.51,8.15-4.26,9.77-1.81,.78-3.72,1.18-5.69,1.18"
      />
      <path
        class="cls-429"
        d="M393.74,84.09c2.16,0,4.26-.44,6.25-1.29,4.43-1.92,6.63-6.98,5.02-11.52l-10.64-30.05c-2.12-5.99-7.81-10.01-14.16-10.01h-56.86v1.39h56.86c5.76,0,10.92,3.65,12.85,9.08l10.64,30.05c1.37,3.86-.51,8.16-4.26,9.78-1.81,.78-3.72,1.18-5.69,1.18"
      />
      <path
        class="cls-455"
        d="M393.74,84.08c2.16,0,4.26-.44,6.24-1.29,4.42-1.91,6.63-6.97,5.02-11.52l-10.64-30.05c-2.12-5.98-7.81-10-14.15-10h-56.86v1.38h56.86c5.76,0,10.93,3.65,12.85,9.08l10.64,30.05c1.37,3.86-.51,8.16-4.27,9.79-1.81,.78-3.73,1.18-5.7,1.18"
      />
      <path
        class="cls-451"
        d="M393.74,84.08c2.16,0,4.26-.44,6.24-1.29,4.42-1.91,6.62-6.97,5.02-11.51l-10.64-30.05c-2.12-5.98-7.8-10-14.15-10h-56.86v1.37h56.86c5.77,0,10.93,3.65,12.86,9.09l10.64,30.05c1.37,3.86-.51,8.17-4.27,9.8-1.81,.78-3.73,1.18-5.7,1.18"
      />
      <path
        class="cls-452"
        d="M393.74,84.07c2.16,0,4.26-.43,6.24-1.29,4.42-1.91,6.62-6.96,5.01-11.5l-10.64-30.05c-2.12-5.98-7.8-10-14.14-10h-56.86v1.36h56.86c5.77,0,10.94,3.65,12.86,9.09l10.64,30.05c1.37,3.87-.51,8.17-4.27,9.8-1.81,.78-3.73,1.18-5.7,1.18"
      />
      <path
        class="cls-593"
        d="M393.74,84.06c2.16,0,4.26-.43,6.24-1.29,4.41-1.91,6.61-6.96,5.01-11.49l-10.64-30.05c-2.12-5.98-7.8-9.99-14.14-9.99h-56.86v1.34h56.86c5.77,0,10.94,3.66,12.87,9.1l10.64,30.05c1.37,3.87-.51,8.18-4.28,9.81-1.81,.78-3.73,1.18-5.7,1.18"
      />
      <path
        class="cls-616"
        d="M393.74,84.06c2.16,0,4.26-.43,6.23-1.29,4.41-1.91,6.61-6.95,5.01-11.49l-10.64-30.05c-2.11-5.97-7.79-9.99-14.13-9.99h-56.86v1.33h56.86c5.77,0,10.95,3.66,12.87,9.1l10.64,30.05c1.37,3.87-.51,8.19-4.28,9.82-1.81,.78-3.73,1.18-5.71,1.18"
      />
      <path
        class="cls-588"
        d="M393.74,84.05c2.16,0,4.25-.43,6.23-1.29,4.41-1.91,6.61-6.95,5-11.48l-10.64-30.05c-2.11-5.97-7.79-9.98-14.12-9.98h-56.86v1.32h56.86c5.78,0,10.95,3.66,12.88,9.1l10.64,30.05c1.37,3.88-.51,8.19-4.28,9.83-1.81,.78-3.73,1.18-5.71,1.18"
      />
      <path
        class="cls-585"
        d="M393.74,84.05c2.16,0,4.25-.43,6.23-1.29,4.41-1.91,6.6-6.94,5-11.47l-10.64-30.05c-2.11-5.97-7.79-9.98-14.12-9.98h-56.86v1.31h56.86c5.78,0,10.96,3.66,12.89,9.11l10.64,30.05c1.37,3.88-.51,8.2-4.29,9.83-1.81,.79-3.74,1.18-5.71,1.18"
      />
      <path
        class="cls-602"
        d="M393.74,84.04c2.16,0,4.25-.43,6.23-1.29,4.4-1.91,6.6-6.94,5-11.46l-10.64-30.05c-2.11-5.97-7.78-9.98-14.11-9.98h-56.86v1.3h56.86c5.78,0,10.96,3.66,12.89,9.11l10.64,30.05c1.37,3.88-.51,8.21-4.29,9.84-1.81,.79-3.74,1.18-5.71,1.18"
      />
      <path
        class="cls-580"
        d="M393.74,84.03c2.15,0,4.25-.43,6.23-1.29,4.4-1.9,6.59-6.94,4.99-11.46l-10.64-30.05c-2.11-5.96-7.78-9.97-14.11-9.97h-56.86v1.28h56.86c5.78,0,10.97,3.66,12.9,9.12l10.64,30.05c1.38,3.89-.51,8.21-4.29,9.85-1.82,.79-3.74,1.18-5.72,1.18"
      />
      <path
        class="cls-579"
        d="M393.74,84.03c2.15,0,4.25-.43,6.22-1.29,4.4-1.9,6.59-6.93,4.99-11.45l-10.64-30.05c-2.11-5.96-7.78-9.97-14.1-9.97h-56.86v1.27h56.86c5.79,0,10.97,3.67,12.9,9.12l10.64,30.05c1.38,3.89-.51,8.22-4.3,9.86-1.82,.79-3.74,1.18-5.72,1.18"
      />
      <path
        class="cls-439"
        d="M393.74,84.02c2.15,0,4.25-.43,6.22-1.29,4.39-1.9,6.58-6.93,4.99-11.44l-10.64-30.05c-2.11-5.96-7.77-9.96-14.1-9.96h-56.86v1.26h56.86c5.79,0,10.98,3.67,12.91,9.12l10.64,30.05c1.38,3.89-.51,8.22-4.3,9.86-1.82,.79-3.74,1.19-5.72,1.19"
      />
      <path
        class="cls-438"
        d="M393.74,84.02c2.15,0,4.24-.43,6.22-1.29,4.39-1.9,6.58-6.92,4.98-11.43l-10.64-30.05c-2.11-5.96-7.77-9.96-14.09-9.96h-56.86v1.25h56.86c5.79,0,10.98,3.67,12.91,9.13l10.64,30.05c1.38,3.89-.51,8.23-4.3,9.87-1.82,.79-3.74,1.19-5.72,1.19"
      />
      <path
        class="cls-572"
        d="M393.74,84.01c2.15,0,4.24-.43,6.22-1.29,4.39-1.9,6.58-6.92,4.98-11.42l-10.64-30.05c-2.11-5.95-7.77-9.96-14.08-9.96h-56.86v1.24h56.86c5.79,0,10.99,3.67,12.92,9.13l10.64,30.05c1.38,3.9-.51,8.24-4.31,9.88-1.82,.79-3.74,1.19-5.72,1.19"
      />
      <path
        class="cls-707"
        d="M393.74,84c2.15,0,4.24-.43,6.21-1.29,4.39-1.9,6.57-6.91,4.98-11.42l-10.64-30.05c-2.11-5.95-7.76-9.95-14.08-9.95h-56.86v1.22h56.86c5.8,0,10.99,3.67,12.93,9.14l10.64,30.05c1.38,3.9-.51,8.24-4.31,9.89-1.82,.79-3.75,1.19-5.73,1.19"
      />
      <path
        class="cls-204"
        d="M393.74,84c2.15,0,4.24-.43,6.21-1.29,4.38-1.9,6.57-6.91,4.97-11.41l-10.64-30.05c-2.11-5.95-7.76-9.95-14.07-9.95h-56.86v1.21h56.86c5.8,0,11,3.67,12.93,9.14l10.64,30.05c1.38,3.9-.51,8.25-4.31,9.89-1.82,.79-3.75,1.19-5.73,1.19"
      />
      <path
        class="cls-205"
        d="M393.74,83.99c2.15,0,4.24-.43,6.21-1.29,4.38-1.9,6.56-6.9,4.97-11.4l-10.64-30.05c-2.11-5.95-7.76-9.94-14.07-9.94h-56.86v1.2h56.86c5.8,0,11,3.67,12.94,9.14l10.64,30.05c1.38,3.91-.51,8.26-4.32,9.9-1.82,.79-3.75,1.19-5.73,1.19"
      />
      <path
        class="cls-203"
        d="M393.74,83.99c2.15,0,4.24-.43,6.21-1.29,4.38-1.89,6.56-6.9,4.97-11.39l-10.64-30.05c-2.1-5.95-7.76-9.94-14.06-9.94h-56.86v1.19h56.86c5.8,0,11.01,3.68,12.94,9.15l10.64,30.05c1.38,3.91-.51,8.26-4.32,9.91-1.82,.79-3.75,1.19-5.73,1.19"
      />
      <path
        class="cls-583"
        d="M393.74,83.98c2.15,0,4.23-.43,6.2-1.28,4.37-1.89,6.55-6.89,4.96-11.39l-10.64-30.05c-2.1-5.94-7.75-9.94-14.06-9.94h-56.86v1.17h56.86c5.81,0,11.01,3.68,12.95,9.15l10.64,30.05c1.38,3.91-.51,8.27-4.32,9.92-1.82,.79-3.75,1.19-5.74,1.19"
      />
    </g>
    <rect class="cls-533" x="324.38" y="29.1" width="5.23" height="5.46" />
    <path
      class="cls-862"
      d="M210.25,28.98h15.96v5.68h-15.96c-.91,0-1.66-.74-1.66-1.66v-2.37c0-.91,.74-1.66,1.66-1.66Z"
    />
    <path
      class="cls-861"
      d="M325.23,38.91h-100.39c-.69,0-1.34-.35-1.75-.95-.67-1-1.5-2.89-1.5-6.13,0-3.44,.8-5.28,1.47-6.21,.4-.56,1.03-.87,1.69-.87h100.48c1.46,0,2.64,1.29,2.64,2.89v8.39c0,1.6-1.18,2.89-2.64,2.89Z"
    />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
